import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import moment from 'moment';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, Badge, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Alert
} from "reactstrap";

import FilesCustom, { ExtUpload } from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';
import WidgetBreadcrumb from 'components/WidgetBreadcrumb';
import PdfViewer from 'components/PdfViewer';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import AGenerateModel from 'components/generic/AGenerateModel';

import { withRouter } from 'components/withRouter';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Editor } from 'components/TinyMCE-react';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import CardLead from 'components/CardLead';
import StatsLead from 'components/StatsLead';

class ManageLeads extends Component {
    static displayName = ManageLeads.name;

    static leadModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    static filesType;

    modalGenManager = React.createRef();

    constructor(props) {
        super(props);

        this.leadGen = React.createRef(null);
        this.statsRef = React.createRef(null);

        var defLeadCategoryGroupKey = "";
        var defLeadPageModels = "";
        if (props.searchParams) {
            defLeadCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defLeadPageModels = props.searchParams.get("pageModels") || "";
        }

        this.state = {
            leads: [], curLead: null, curLeadId: 0, status: [], defaultStatus: 3001, curStatus: 3001/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1",
            title: props.i18nManager.t("lead.noSelected"), editionMode: false, categoryGroupKey: defLeadCategoryGroupKey, pageModels: defLeadPageModels, onlyActives: true, altMode: false,
            expandAll: null,
            expandStamp: 0,
            currentPage: 1,
            showIARecoBtn: props.getSite()?.extras?.filter(extra => extra.name === "useAILeadRecommandation" && (extra.value === "true" || extra.value === "1")).length > 0
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;
        const svcParentIDSurvey = 1000;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            //commonFunc.getMethod("../api/lead/GetLeadModels", { id: -1 }).then((responseModels) => {
            commonFunc.getMethod("../api/data/GetAllModels", { filter: "lead"/*, categ: context.state.categ*/, useParentSite: true, excludeMode: 1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.leadModels = {};
                    //dataModels.result.models.forEach((model) => {
                    dataModels.result.map(model => model.tag).forEach((model) => {
                        var modelObj = JSON.parse(model.value);
                        if (!modelObj.objType) {//Array.isArray(modelObj)
                            var useSub = false;
                            Object.keys(modelObj).forEach(key => {
                                var subModel = modelObj[key];
                                if (subModel.objType) {
                                    useSub = true;
                                    context.leadModels[key] = subModel;
                                }
                            });
                            if (!useSub) context.leadModels[model.extID] = modelObj;
                        }
                        else context.leadModels[model.extID] = modelObj;
                    });

                    var configStatus = context.state.curStatus;
                    var altMode = false;
                    var updateConfigs = false;
                    if (context.leadModels["LEAD_CONFIGS"]) {
                        var configPage = context.leadModels["LEAD_CONFIGS"][context.state.pageModels];
                        configStatus = (configPage?.srcObject?.defaultStatus || configStatus);
                        altMode = configPage?.srcObject?.altMode;
                        updateConfigs = true;

                        if (configPage?.srcObject?.redirect) {
                            //navigate("../home");
                            context.setState({ redirect: configPage?.srcObject?.redirect });
                        }
                    }



                    //context.leadModels["CONTACTS"] = {};
                    //context.leadModels["DT_CTCS"] = {};
                    //context.leadModels["DLG_CONTACT"] = {};


                    var newSiteFilter;
                    var newGroupFilter;
                    var newServiceFilter;

                    var initPage = () => {
                        var newStates = {};
                        if (newSiteFilter) newStates.assignSiteFilter = newSiteFilter;
                        if (newGroupFilter) newStates.groupFilter = newGroupFilter;
                        if (newServiceFilter) newStates.serviceFilter = newServiceFilter;
                        if (newSiteFilter || newGroupFilter || newServiceFilter) context.setState({ ...newStates });

                        //Chargement via url
                        var defLeadLoadId = 0;
                        var defLeadActionId = 0;
                        if (context.props.searchParams) {
                            defLeadLoadId = parseInt(context.props.searchParams.get("leadId")) || 0;
                            defLeadActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                        }
                        if (defLeadLoadId > 0) {
                            var defLeadStatusId = parseInt(context.props.searchParams.get("statusId")) || configStatus;

                            context.loadStatusBtnGrp(defLeadStatusId);

                            context.getLeads(defLeadStatusId, false, function () {
                                if (altMode) {
                                    var element = document.querySelector('.card-' + defLeadLoadId);
                                    if (element) {
                                        const elementBottom = element.offsetTop - 68;//marginTop - mainPanel/content
                                        context.props.getScroller().smoothScroll(elementBottom);
                                        context.refreshCb = null;
                                    }
                                }
                                else {
                                    if (context) {
                                        context.loadReportCb = () => {
                                            if (defLeadActionId) context.switchTab(defLeadActionId.toString());

                                            //setTimeout(function () {
                                            var element = document.querySelector('.tableContainer');
                                            const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                            context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                            //}, 2000);
                                        };
                                    }
                                    showDtSelID("tableLeads", defLeadLoadId);
                                }
                            }, null, context.state.showIARecoBtn);
                            if (updateConfigs) context.setState({ curStatus: configStatus, altMode: altMode });
                        } else {
                            context.loadStatusBtnGrp(configStatus);

                            if (updateConfigs) context.setState({ curStatus: configStatus, altMode: altMode });
                            else context.getLeads(null, null, null, null, context.state.showIARecoBtn);

                            if (defLeadActionId) context.switchTab(defLeadActionId.toString());

                            /*if (defLeadActionId == 1) {
                                $(".action-addReport:visible").click();
                            }*/
                        }
                    };

                    var fileTypesFunc = () => {
                        context.filesType = null;
                        if (altMode) {
                            commonFunc.getMethod("../api/lead/GetLeadFilesType", null).then((response) => {
                                if (response.data && response.data.isSuccess) {
                                    context.filesType = response.data.result.filter(type => type.refExtID !== "AVA");
                                    initPage();
                                }
                                else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de chargement des Types de Fichier :<br>" + response.data.errorMessage
                                    });
                                    initPage();
                                }
                            });
                        }
                        else initPage();
                    };

                    if (context.state.pageModels === "SURVEY") {
                        commonFunc.getMethod("../api/site/GetSites", null).then((responseSites) => {
                            if (responseSites.data && responseSites.data.isSuccess) {
                                context.sites = responseSites.data.result;
                                if (context.sites?.length) newSiteFilter = context.sites[0].idSite;

                                commonFunc.getMethod("../api/lead/GetLeadGroups", null).then((responseGroups) => {
                                    if (responseGroups.data && responseGroups.data.isSuccess) {
                                        context.groups = responseGroups.data.result.filter(group => group.idSegment > 0);
                                        if (context.groups?.length) newGroupFilter = context.groups[0].idSegment;

                                        commonFunc.getMethod("../api/lead/GetLeadServices", null).then((response) => {
                                            if (response.data && response.data.isSuccess) {
                                                context.services = response.data.result.filter(service => service.parentID === svcParentIDSurvey);

                                                if (context.services?.length) newServiceFilter = context.services[0].idService;
                                                fileTypesFunc();
                                            }
                                            else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: "Echec",
                                                    html: "Echec de chargement des services :<br>" + response.data.errorMessage
                                                });
                                                fileTypesFunc();
                                            }
                                        });
                                    }
                                    else {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: "Echec de chargement des groupes :<br>" + responseGroups.data.errorMessage
                                        });
                                        fileTypesFunc();
                                    }
                                });

                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec de chargement des sites :<br>" + responseSites.data.errorMessage
                                });
                                fileTypesFunc();
                            }
                        });
                    }
                    else {
                        fileTypesFunc();
                    }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.searchParams !== prevProps.searchParams) {
            window.location.reload();
            return;
        }

        var isProjectPage = (this.state.pageModels === "PROJECTLEAD" || this.state.pageModels === "PTECHLEAD");

        //console.debug("UPDATE");
        /*prevState.historicalReports !== this.state.historicalReports || */
        if (prevState.curStatus !== this.state.curStatus || prevState.onlyActives !== this.state.onlyActives || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels
            || (isProjectPage && this.state.switchDisplay && prevState.switchDisplay !== this.state.switchDisplay)
            || (this.state.pageModels === "SURVEY" && (prevState.switchDisplay !== this.state.switchDisplay || (this.state.serviceFilter && prevState.serviceFilter && prevState.serviceFilter !== this.state.serviceFilter)
                || (this.state.assignSiteFilter && prevState.assignSiteFilter && prevState.assignSiteFilter !== this.state.assignSiteFilter)
                || (this.state.groupFilter && prevState.groupFilter && prevState.groupFilter !== this.state.groupFilter)))) {

            if (this.state.leads.length) this.getLeads();
            else this.getLeads(null, null, null, null, this.state.showIARecoBtn);
        }
        else {
            var defLeadCategoryGroupKey = "";
            var defLeadPageModels = "";
            if (this.props.searchParams) {
                defLeadCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defLeadPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defLeadCategoryGroupKey || this.state.pageModels !== defLeadPageModels) {
                this.setState({ categoryGroupKey: defLeadCategoryGroupKey, pageModels: defLeadPageModels });
            }


            if (prevState.currentPage !== this.state.currentPage) {
                var context = this;

                var filteredLeads = context.state.leads.filter(lead => {
                    if (context.state.assignSiteFilter > 0 && lead.assignSiteID !== context.state.assignSiteFilter) return false;
                    if (context.state.serviceFilter > 0 && lead.serviceID !== context.state.serviceFilter) return false;
                    if (context.state.groupFilter > 0 && lead.groupID !== context.state.groupFilter) return false;
                    if (context.state.pageModels === "DIALOGLEAD" && context.state.curStatus > 3000 && lead.statusID !== context.state.curStatus) return false;
                    if (context.state.pageModels === "SURVEY" && (lead.categoryID !== 5 && !(lead.parentID > 0))) return false;
                    return !(lead.idLead <= 0);
                });
                if (filteredLeads.length) {
                    //context.setState({ leads: context.state.leads, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                    context.loadLead(filteredLeads[this.state.currentPage - 1].idLead, filteredLeads[this.state.currentPage - 1]);
                    return;
                }
            }
        }

        //Update Scroller Size
        /*if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }*/
        if (this.props.getScroller) this.props.getScroller()?.update();

        //Callback initCreateLead
        if (this.state.curLeadId === 0 /*&& prevState.curLeadId !== this.state.curLeadId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableLeads"]) this.dtFunctions["tableLeads"].setDisabled(this.state.editionMode);


        if (this.state.altMode && !this.state.switchDisplay) {
            if (this.refreshCb) {
                if (this.refreshCb && typeof (this.refreshCb) === "function") { this.refreshCb(); }
            }
        }
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;

        if (context.state.redirect) {
            return <Navigate to={context.state.redirect} replace={true} />;
        }

        const importCategIDSurvey = 6;

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadLead(rowData.idLead, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idLead;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadLead(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadLead();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
        var pageConfig = {
            "objType": "model", "templates": [
                { "title": "i18n:lead.tabDetails", "objType": "template", "subType": "LEAD", "checkRights": { "entity": "LEAD", "rights": "R" } },
                { "title": "i18n:lead.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "LEAD_CONTACTS", "rights": "L" } },
                { "title": "i18n:lead.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "LEAD_FILES", "rights": "L" } },
                { "title": "i18n:lead.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "LEAD_FLOWS", "rights": "L" } },
                { "title": "i18n:lead.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "LEAD", "rights": "C" } }
            ]
        };
        if (context.leadModels && context.leadModels["LEAD_CONFIGS"]) {
            pageConfig = context.leadModels["LEAD_CONFIGS"][context.state.pageModels] || pageConfig;
        }

        var tableConfig = "DT_LEADS";
        if (context.state.pageModels === "SURVEY") tableConfig = "DT_SURVEY";


        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();

            var srcRoles = curUser.roles;
            var haveCustomProfiles = curUser.roles.filter(role => role.startsWith("PRFL_"));
            srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
            var targetRoles = srcRoles ? srcRoles[0] : null;

            var leadModel;
            var srcModel;
            var resFilter = Object.keys(this.leadModels).filter((key) => {
                var model = this.leadModels[key];
                if (key === "LEAD" || key === ("LEAD_" + this.state.curLead?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "LEAD_" + targetRoles || (key === ("LEAD_" + this.state.curLead?.categoryID + "_") + targetRoles);
            });
            if (resFilter && resFilter.length) {
                leadModel = this.leadModels[resFilter[0]];
            }
            else if (srcModel) {
                leadModel = srcModel;
            }
            else {
                leadModel = this.leadModels ? (this.leadModels["LEAD_" + this.state.curLead?.categoryID] || this.leadModels["LEAD"]) : {};
            }
            if (context.state.pageModels === "SURVEY") leadModel = this.leadModels ? this.leadModels["LEAD_SURVEY" + (context.state.curLead?.serviceID > 0 ? ("_" + context.state.curLead?.serviceID) : ("_" + context.state.serviceFilter))] : null;

            var filesAltObj = {};
            if (context.filesType) filesAltObj.filesType = context.filesType;
            else filesAltObj.altFilesTypes = "../api/lead/GetLeadFilesType";

            //Gestion onglet Documents
            if (this.state.altMode && context.state.curLead?.leadFiles?.length) {
                filesAltObj.files = context.state.curLead?.leadFiles.map(tf => tf.file);
                //filesAltObj.noRemove = true; //TODO : Voir si on verrouille dans tout les cas ou on laisse la main qu'aux sites concernés
                filesAltObj.setFiles = (cptFiles) => { context.loadLead(context.state.curLeadId); };
            }


            var saveCb = () => {
                //context.loadLead(leadResponse.result.idLead);
                context.getLeads(3000, true, () => {
                    //showDtSelID("tableLeads", data.result.idLead);
                });
            };


            var cptSysCollection = {
                "LEAD": <ShowDetails id={this.state.curLeadId} type="lead" genRef={this.leadGen} data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={leadModel} modelsList={this.leadModels}
                    loadElem={this.loadLead.bind(this)} saveElem={this.contextSaveLead.bind(this)} removeElem={this.removeLead.bind(this)} updateStatusElem={this.updateLeadStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()}
                    dialogShowLead={() => { dialogAltLead(context.props.i18nManager.t("lead.tabDetails"), "DLG_LEAD", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogEditLead={() => { showDialogLead(altT(templatesWidgetList[0].name), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogDuplicateLead={() => { showDialogLead(altT(templatesWidgetList[0].name.replace("edit", "duplicate")), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager, true); }}
                    manageEmail={() => { sendEmailDialog(this.state.curLead, context.props.dataCfg, context.props.i18nManager); }}
                    manageRecapEmail={() => { sendRecapEmailDialog(this.state.curLead, context.props.dataCfg, context.props.i18nManager); }}
                    dialogLossLead={() => { dialogAltLead(context.props.i18nManager.t("lead.leadloss"), "LEADLOSS", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogScheduleVisit={() => { dialogAltLead(context.props.i18nManager.t("lead.scheduleVisit"), "SCHEDULEVISIT", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}
                    manageShopOrder={() => { context.manageShopOrder(this.state.curLead, context) }}
                    generateLeadRecap={() => { context.generateLeadRecap(this.state.curLead) }}
                    newRecall={() => { context.newRecall(this.state.curLead) }} />,
                "CONTACTS": <ShowDetails id={this.state.curLeadId} type="leadContacts" data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.leadModels ? this.leadModels["CONTACTS"] : {}} modelsList={this.leadModels} shouldRender={this.state.activeTab === index.toString()} />,
                "CONTACTS_MSITES": <ShowDetails id={this.state.curLeadId} type="leadContacts" data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.leadModels ? this.leadModels["CONTACTS_MSITES"] : {}} modelsList={this.leadModels}
                    loadElem={this.loadLead.bind(this)} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="lead-files" bindID={this.state.curLeadId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="LEAD" src={this.state.curLead} waitForCompletion={(fileUpReq) => { return fileUpReq.ftype === "DVS"; }}
                        srcName={this.state.curLead ? this.state.curLead.title : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"DVS"} {...filesAltObj}
                        altFilesUrl="../api/lead/GetLeadFiles" altRemoveFilesUrl="../api/lead/RemoveLeadFile" altUploadFilesUrl="../api/lead/UploadLeadFiles" />
                </Form>,//noRemove={/*this.state.altMode ? "PDF" :*/ false}
                "FLOWS": <Row className="lead-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("lead.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="lead" elemId={context.state.curLeadId} rows={context.state.curLead?.flows} url="../api/lead/GetLeadFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };

        var isProjectPage = (context.state.pageModels === "PROJECTLEAD" || context.state.pageModels === "PTECHLEAD");

        var validLeads = this.state.leads.filter(lead => {
            return !(lead.idLead <= 0);
        });
        var filteredLeads = validLeads.filter(lead => {
            if (context.state.assignSiteFilter > 0 && lead.assignSiteID !== context.state.assignSiteFilter) return false;
            if (context.state.serviceFilter > 0 && lead.serviceID !== context.state.serviceFilter) return false;
            if (context.state.groupFilter > 0 && lead.groupID !== context.state.groupFilter) return false;
            if (context.state.pageModels === "DIALOGLEAD" && context.state.curStatus > 3000 && lead.statusID !== context.state.curStatus) return false;
            if (context.state.pageModels === "SURVEY" && (lead.categoryID !== 5 && !(lead.parentID > 0))) return false;

            var searchProc = (field, searchField) => {
                var editField = field.trim().replaceAll(" ", "").toLowerCase();
                editField = editField
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c');
                var editSearchField = searchField || (context.state.searchField?.trim()/*.replaceAll(" ", "")*/.toLowerCase()
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c'));

                var splitField = editSearchField?.split(" ");
                if (splitField?.length > 1) {
                    var flag = true;
                    splitField.forEach(subField => {
                        flag &= searchProc(field, subField);
                    });
                    return flag;
                }
                else return editField.indexOf(editSearchField) >= 0;

                //return editField.indexOf(editSearchField) >= 0;
            };

            if (isProjectPage) {
                if (context.state.searchField && !(searchProc(lead.title) || searchProc(lead.address?.city) || searchProc(lead.refExtID) || searchProc(lead.extRef))) return false;
            }
            else if (context.state.searchField && !(searchProc(lead.title) || searchProc(lead.client?.name) || searchProc(lead.client?.firstName) || searchProc(lead.client?.name + " " + lead.client?.firstName) || searchProc(lead.tel) || searchProc(lead.status?.name))) return false;
            return true;
        }).sort((a, b) => {
            if (a.priority !== b.priority) {
                return b.priority - a.priority;
            }
            /*else if (a.priority && b.priority) {
                return moment(a.dSysMod).diff(b.dSysMod, "seconds");
            }*/
            return moment(b.dSysMod).diff(a.dSysMod, "seconds");
        });

        var templatesWidgetList = pageConfig?.templates?.filter(template => template.objType === "widgetList");
        if (!context.state.switchDisplay && templatesWidgetList.length > 0) {
            try {
                if (isProjectPage) {
                    return this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                        <div className="oskala-project">
                            {/* ==========================================
    TOOLBAR
    ========================================== */}
                            <div className="projets-toolbar">
                                <div className="projets-toolbar-left">
                                    {/* Switch vue table/cards */}
                                    <Button className="btn-icon btn-round mt-0" color="primary" onClick={() => {
                                        context.setState({ switchDisplay: !context.state.switchDisplay, serviceFilter: -1, searchField: "", onlyActives: false, dataStamp: new Date().getTime() });
                                    }}><i className="fa fa-table"></i></Button>

                                    {/* Actualiser */}
                                    <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" onClick={() => this.getLeads()}>
                                        <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                    </Button>

                                    {/* Nouveau Projet */}
                                    {pageConfig?.templates?.map((template, index) => {
                                        if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                            switch (template.subType) {
                                                case "ADD":
                                                    return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => this.initCreateLead()}>
                                                        <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                                    </Button>;
                                                case "DIALOGADD":
                                                    var saveCb = (leadResponse) => {
                                                        context.getLeads(3000, true, () => { });
                                                    };
                                                    return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                        <i className="fa fa-user-plus fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                                    </Button>;
                                                default: return "";
                                            }
                                        }
                                        else return "";
                                    })}

                                    {/* Compteur */}
                                    <span className="projets-results-count">
                                        <strong>{filteredLeads.length}</strong> élément(s)
                                        {(validLeads.length - filteredLeads.length) > 0 && ` (filtré de ${validLeads.length} au total)`}
                                    </span>
                                </div>

                                <div className="projets-toolbar-right">
                                    {/* Recherche */}
                                    <Label className="projets-filter-label" for="inputSearch">{context.props.i18nManager.t("lead.inputSearchFilter")}</Label>
                                    <Input id={"inputSearch"} bsSize="sm" className="projets-filter-select" placeholder={context.props.i18nManager.t("lead.inputSearchHolder")} type="text" autoComplete="off" aria-autocomplete="none" onChange={(e) => {
                                        context.setState({ searchField: e.target.value });
                                    }} />

                                    {/* Filtre Prestation */}
                                    {/*<Label className="projets-filter-label" for="selectService">{context.props.i18nManager.t("lead.serviceFilter")}</Label>
                                <Input id={"selectService"} bsSize="sm" className="projets-filter-select" type="select" onChange={(e) => {
                                    context.setState({ serviceFilter: parseInt(e.target.value) });
                                }} value={context.state.serviceFilter}>
                                    {(() => {
                                        var allOpt = { selected: true, title: "Tous", value: -1 };
                                        var options = [];
                                        var values = {};
                                        validLeads.forEach((row) => {
                                            var label = row.service?.name;
                                            var value = row.serviceID;
                                            if (value && label && !values[value]) {
                                                values[value] = value;
                                                options.push({ title: label, value: value });
                                            }
                                        });
                                        options.unshift(allOpt);
                                        return options.map((option, index) => (
                                            <option key={index} value={option.value}>{option.title}</option>
                                        ));
                                    })()}
                                </Input>*/}

                                    {/* Filtre Association */}
                                    <Label className="projets-filter-label" for="selectAssignSite">{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                    <Input id={"selectAssignSite"} bsSize="sm" className="projets-filter-select" type="select" onChange={(e) => {
                                        context.setState({ assignSiteFilter: parseInt(e.target.value) });
                                    }} value={context.state.assignSiteFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];
                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.extSite?.name;
                                                var value = row.assignSiteID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });
                                            options.unshift(allOpt);
                                            return options.map((option, index) => (
                                                <option key={"site" + index} value={option.value}>{option.title}</option>
                                            ));
                                        })()}
                                    </Input>

                                    {/* Actif uniquement */}
                                    <label className="projets-checkbox-filter">
                                        <input type="checkbox" checked={context.state.onlyActives} onChange={(e) => {
                                            context.setState({ onlyActives: e.target.checked });
                                        }} />
                                        <span>{context.props.i18nManager.t("lead.onlyactivesFilter")}</span>
                                    </label>

                                    {/* Expand / Collapse */}
                                    <div className="expand-collapse-group">
                                        <button
                                            className={`btn-expand-all ${context.state.expandAll === true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: true, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-expand-alt"></i> Tout déplier
                                        </button>
                                        <button
                                            className={`btn-collapse-all ${context.state.expandAll !== true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: false, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-compress-alt"></i> Tout replier
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="projets-group">
                                {filteredLeads.map(lead => {

                                    var statusOrder = [3001, 3002, 3003, 3004, 3097, 3005, 3006, 3007];

                                    try {
                                        return <CardLead
                                            key={`project-${lead.idLead}`}
                                            variant="project"
                                            lead={lead}
                                            context={context}
                                            t={context.props.i18nManager.t} altT={altT}
                                            templatesWidgetList={templatesWidgetList}
                                            statusOrder={statusOrder}
                                            expandAll={this.state.expandAll}
                                            expandStamp={this.state.expandStamp}
                                        />;
                                    }
                                    catch (e) {
                                        console.error(e);
                                        return <div key={"leaderror" + lead.idLead} className="badge badge-danger my-3">Une erreur est survenu lors du chargement de ce widget {"- " + lead.idLead + " " + lead.client?.name + " - " + lead.service?.name}</div>
                                    }
                                })}
                            </div>
                        </div>;


                }
                else if (context.state.pageModels === "DIALOGLEAD") {
                    return this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                        <div className="oskala-lead">
                            {/* ==========================================
                                STATS CARDS
                                ========================================== */}
                            <StatsLead ref={context.statsRef} i18nManager={context.props.i18nManager} {...context.leadModels["STATS_CFG"]} />

                            {/* ==========================================
                                TOOLBAR
                                ========================================== */}
                            <div className="leads-toolbar">
                                <div className="leads-toolbar-left w-100">
                                    {/* Switch vue */}
                                    <Button className="btn-icon btn-round mt-0" color="primary" onClick={() => {
                                        var supStates = {};
                                        if (context.state.curStatus === -1) supStates.curStatus = 3000;
                                        context.setState({ switchDisplay: !context.state.switchDisplay, serviceFilter: -1, searchField: "", onlyActives: false, dataStamp: new Date().getTime(), ...supStates });
                                    }}><i className="fa fa-table"></i></Button>

                                    {/* Actualiser */}
                                    <Button className="btn-icon btn-rotate px-2 mt-0" disabled={this.state.editionMode} color="secondary" onClick={() => this.getLeads()}>
                                        <i className="fa fa-sync"></i>
                                    </Button>

                                    {/* Nouveau Prospect */}
                                    {pageConfig?.templates?.map((template, index) => {
                                        if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                            switch (template.subType) {
                                                case "ADD":
                                                    return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => this.initCreateLead()}>
                                                        <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                                    </Button>;
                                                case "DIALOGADD":
                                                    var saveCb = (leadResponse) => {
                                                        context.getLeads(3000, true, () => { });
                                                    };
                                                    return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                        <i className="fa fa-user-plus fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                                    </Button>;
                                                default: return "";
                                            }
                                        }
                                        else return "";
                                    })}

                                    {/* Compteur */}
                                    <span className="leads-results-count">
                                        <strong>{filteredLeads.length}</strong> élément(s)
                                        {(validLeads.length - filteredLeads.length) > 0 && ` (filtré de ${validLeads.length} au total)`}
                                    </span>

                                    {context.state.showIARecoBtn ? <>&bull;

                                        <Button key={"iarecobtn"} className={`btn-magnify px-2 mt-0`} color="info" onClick={() => {
                                            context.setState({ displayRecommandations: !context.state.displayRecommandations });
                                        }}>
                                            <i className="fa fa-wand-magic-sparkles fa-lg"></i>{context.props.i18nManager.t("lead.useIAReco")}<strong>{context.state.recommandations?.length || 0}</strong> {context.props.i18nManager.t("lead.recoLabel")}
                                        </Button>
                                    </> : ""}

                                    {/* Stats */}
                                    <div className="text-end" style={{ flex: "auto" }}>
                                        <Button className="btn-icon btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="info" onClick={() => { if (context.statsRef?.current) context.statsRef.current.displayStats(); }}>
                                            <i className="fa fa-chart-line"></i>
                                        </Button>
                                    </div>
                                </div>

                                {context.state.showIARecoBtn && context.state.displayRecommandations && context.state.recommandations?.length ? <Card className="leads-reco w-100">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <div className="text-end">
                                                    <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" onClick={() => {
                                                        this.setState({ recommandations: [] });
                                                        this.getLeads(null, null, null, null, true)
                                                    }}>
                                                        <i className="fa fa-sync"></i>
                                                    </Button>
                                                </div>
                                                <ul class="task-list">
                                                    {context.state.recommandations.map(reco => {
                                                        if (!reco.title) {
                                                            var leadSrc = filteredLeads.filter(lead => lead.idLead === reco.leadId);
                                                            if (leadSrc.length) {
                                                                reco.title = leadSrc[0].client?.name.toUpperCase() + " " + commonFunc.capitalize(leadSrc[0].client?.firstName);
                                                            }
                                                        }
                                                        return (<li onClick={() => {
                                                            var element = document.querySelector('.lead-' + reco.leadId);
                                                            if (element) {
                                                                element.classList.remove("collapsed");
                                                                context.props?.getScroller()?.smoothScroll(element.offsetTop - context.props?.getScroller().element.offsetTop - 85, 1000);
                                                            }
                                                        }}>{reco.title ? <><b>{reco.title}</b> —</> : ""} <i className={`fa ${altT("i18n:lead.recoIcon" + reco.recommendedAction)}`}></i><span className="text-secondary">{reco.reason}</span></li>);
                                                    })}
                                                </ul>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card> : ""}

                                <div className="leads-toolbar-right">
                                    {/* Recherche */}
                                    <Label className="leads-filter-label" for="inputSearch">{context.props.i18nManager.t("lead.inputSearchFilter")}</Label>
                                    <Input id={"inputSearch"} bsSize="sm" className="leads-filter-select" placeholder={context.props.i18nManager.t("lead.inputSearchHolder")} type="text" autoComplete="off" aria-autocomplete="none" onChange={(e) => {
                                        context.setState({ searchField: e.target.value });
                                    }} />

                                    {/* Prestation */}
                                    <Label className="leads-filter-label" for="selectService">{context.props.i18nManager.t("lead.serviceFilter")}</Label>
                                    <Input id={"selectService"} bsSize="sm" className="leads-filter-select" type="select" onChange={(e) => {
                                        context.setState({ serviceFilter: parseInt(e.target.value) });
                                    }} value={context.state.serviceFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];
                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.service?.name;
                                                var value = row.serviceID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });
                                            options.unshift(allOpt);
                                            return options.map((option, index) => (
                                                <option key={"service" + index} value={option.value}>{option.title}</option>
                                            ));
                                        })()}
                                    </Input>

                                    {/* Association */}
                                    <Label className="leads-filter-label" for="selectAssignSite">{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                    <Input id={"selectAssignSite"} bsSize="sm" className="leads-filter-select" type="select" onChange={(e) => {
                                        context.setState({ assignSiteFilter: parseInt(e.target.value) });
                                    }} value={context.state.assignSiteFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];
                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.extSite?.name;
                                                var value = row.assignSiteID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);
                                            return options.map((option, index) => (
                                                <option key={"site" + index} value={option.value}>{option.title}</option>
                                            ));
                                        })()}
                                    </Input>

                                    {/* Status */}
                                    <Label className="leads-filter-label" for="selectStatus">{context.props.i18nManager.t("lead.statusFilter")}</Label>
                                    <Input id={"selectStatus"} bsSize="sm" className="leads-filter-select" type="select" onChange={(e) => {
                                        context.setState({ curStatus: parseInt(e.target.value), onlyActives: parseInt(e.target.value) === -1 });
                                    }} value={context.state.onlyActives ? -1 : context.state.curStatus}>
                                        {(() => {
                                            var essentialOpt = { selected: true, title: "Actif uniquement", value: -1 };
                                            //var allOpt = { title: "Tous", value: -1 };
                                            var options = [];
                                            context.state.status.forEach((row) => {
                                                options.push({
                                                    title: <>
                                                        {(() => {
                                                            var classFa = "";
                                                            if (row.css?.indexOf("fa-")) {
                                                                row.css.split(" ").forEach((classElem) => {
                                                                    //console.debug(classElem.startsWith("fa-") + classElem);
                                                                    classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                                });
                                                            }
                                                            return <i className={`fa ${classFa} me-1`}></i>
                                                        })()}
                                                        {altT(row.name)}
                                                    </>, value: row.idStatus
                                                });
                                            });

                                            //options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(essentialOpt);
                                            //options.push(allOpt);
                                            return options.map((option, index) => (
                                                <option key={"status" + index} value={option.value}>{option.title}</option>
                                            ));
                                        })()}
                                    </Input>

                                    {/* Actif uniquement */}
                                    <label className="leads-checkbox-filter d-none">
                                        <input type="checkbox" checked={context.state.onlyActives} onChange={(e) => {
                                            context.setState({ onlyActives: e.target.checked });
                                        }} />
                                        <span>{context.props.i18nManager.t("lead.onlyactivesFilter")}</span>
                                    </label>

                                    {/* Expand / Collapse */}
                                    <div className="expand-collapse-group">
                                        <button
                                            className={`btn-expand-all ${context.state.expandAll === true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: true, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-expand-alt"></i> Tout déplier
                                        </button>
                                        <button
                                            className={`btn-collapse-all ${context.state.expandAll !== true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: false, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-compress-alt"></i> Tout replier
                                        </button>
                                    </div>
                                </div>
                            </div>





                            <div className="leads-group">
                                {filteredLeads.map(lead => {
                                    try {
                                        // Configuration des statuts
                                        var statusOrder = [3001, 3002, 3003, 3004, 3007, 3008, 3009, 3005, 3006];
                                        var statusDesc = 3002;

                                        var hasPrices = lead.extras?.filter(extra => extra.name === "generatePrices" && extra.value === "true");
                                        hasPrices = hasPrices?.length > 0;
                                        if (!hasPrices) statusOrder = statusOrder.filter(status => status !== 3003);

                                        var visitExtras = lead.extras?.filter(extra => extra.name === "shouldVisit");
                                        var shouldVisit = (visitExtras?.length <= 0 && lead.serviceID === 801) || (visitExtras?.length && visitExtras[0].value === "true");
                                        if (!shouldVisit) statusOrder = statusOrder.filter(status => status !== 3004 && status !== 3007);

                                        return (
                                            <CardLead
                                                key={`lead-${lead.idLead}`}
                                                variant="lead"
                                                lead={lead}
                                                context={context}
                                                t={context.props.i18nManager.t} altT={altT}
                                                templatesWidgetList={templatesWidgetList}
                                                descActions={/*statusDesc === lead.statusID ? */<div style={{ position: "absolute", left: 0, right: 0, bottom: "-28px" }}>
                                                    <Button type="button" className="btn-sm btn-icon rounded-circle" color={lead.description ? "success" : "secondary"} style={{ width: "36px", height: "36px" }} title="Commentaire" onClick={() => {
                                                        var saveCb = () => {
                                                            //context.loadLead(leadResponse.result.idLead);
                                                            context.getLeads(3000, true, () => {
                                                                //showDtSelID("tableLeads", data.result.idLead);
                                                            });
                                                        };
                                                        showDialogLead("Commentaire", "COMMENTS", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager);
                                                        //dialogAltLead("Commentaire", "COMMENTS", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)
                                                    }}><i className="fa fa-comment-dots"></i></Button>
                                                </div>/* : null*/}
                                                statusOrder={statusOrder}
                                                hasPrices={hasPrices} shouldVisit={shouldVisit} recall={lead.recall}
                                                expandAll={this.state.expandAll}
                                                expandStamp={this.state.expandStamp}
                                            />
                                        );
                                    }
                                    catch (e) {
                                        console.error(e);
                                        return <div key={"leaderror" + lead.idLead} className="badge badge-danger my-3">
                                            Une erreur est survenu lors du chargement de ce widget {" - " + lead.idLead + " " + lead.client?.name + " - " + lead.service?.name}
                                        </div>
                                    }
                                })}
                            </div>
                        </div>;
                }
                else {
                    return "";
                }
            }
            catch (e) {
                console.error(e);
                return <div>Une erreur est survenu lors du chargement de la liste widget</div>
            }
        }
        else if (!context.state.switchDisplay && context.state.pageModels === "SURVEY") {
            var serviceModifier = (context.state.curLead?.serviceID > 0 ? ("_" + context.state.curLead?.serviceID) : ("_" + context.state.serviceFilter));
            var groupModifier = (context.state.curLead?.groupID > 0 ? ("_" + context.state.curLead?.groupID) : ("_" + context.state.groupFilter));
            var leadModel = this.leadModels ? (this.leadModels["LEAD_SURVEY" + groupModifier + serviceModifier] || this.leadModels["LEAD_SURVEY" + serviceModifier]) : null;

            var saveCb = () => {
                //context.loadLead(leadResponse.result.idLead);
                context.getLeads(3000, true, () => {
                    //showDtSelID("tableLeads", data.result.idLead);
                });
            };

            var currentGroupFiltered = context.groups?.filter(grp => grp.idSegment === context.state.groupFilter);
            var groupLocked = (currentGroupFiltered?.length ? currentGroupFiltered[0].statusID !== 2 : true);

            var surveyGlobalStats = context.statsRef?.current?.getGlobalStats();

            return (
                this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> : <div className={`oskala-survey ${groupLocked ? "form-locked" : ""}`}>
                    <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                        <CardHeader>
                            <CardTitle tag="h6">{context.props.i18nManager.t("lead.surveyTitle")}</CardTitle>
                            <div className="widget-tools collapse-tool">
                                <i className="fa fa-table-list fa-4x"></i>
                            </div>
                            <div className='borderTheme'></div>
                        </CardHeader>
                        <CardBody>
                            <div className="float-start">
                                {/* Switch vue */}
                                <Button className="btn-icon btn-round mt-0 mb-0" color="primary" onClick={() => {
                                    var supStates = {};
                                    if (context.state.curStatus === -1) supStates.curStatus = 3000;
                                    context.setState({ switchDisplay: !context.state.switchDisplay, searchField: "", assignSiteFilter: -1, serviceFilter: -1, onlyActives: false, dataStamp: new Date().getTime(), ...supStates });//, serviceFilter: -1
                                }}><i className="fa fa-table"></i></Button>

                                <Button className="btn-rotate px-2 btn-simple mt-0 mb-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getLeads()}>
                                    <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                </Button>


                                {/* Type Enquête */}
                                <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectGroup"}>{context.props.i18nManager.t("lead.groupSurveyFilter")}</Label>
                                <Input id={"selectGroup"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "250px" }} onChange={(e) => {
                                    context.setState({ groupFilter: parseInt(e.target.value), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                }} value={context.state.groupFilter}>
                                    {(() => {
                                        //var allOpt = { selected: true, title: "Tous", value: -1 };
                                        var options = [];

                                        var values = {};
                                        context.groups?.forEach((row) => {
                                            var label = row.title;
                                            var value = row.idSegment;
                                            if (value && label && !values[value]) {
                                                values[value] = value;
                                                options.push({ title: label, value: value });
                                            }
                                        });

                                        //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                        //options.unshift(allOpt);

                                        return options.map((option, index) => {
                                            return <option className={`${option.hidden ? "d-none" : ""}`} key={"group" + index} value={option.value}>
                                                {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                {option.title}
                                            </option>
                                        });
                                    })()}
                                </Input>

                                {/* Asso. */}
                                <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSiteT"}>{context.props.i18nManager.t("lead.siteSurveyFilter")}</Label>
                                <Input id={"selectAssignSiteT"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                    var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                    var curFilter = selValue;
                                    context.setState({ assignSiteFilter: parseInt(curFilter), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                }} value={context.state.assignSiteFilter}>
                                    {(() => {
                                        var allOpt = { selected: true, title: "Global", value: -1 };
                                        var options = [];

                                        var values = {};
                                        context.sites?.forEach((row) => {
                                            var label = row.name;
                                            var value = row.idSite;
                                            if (value && label && !values[value]) {
                                                values[value] = value;
                                                options.push({ title: label, value: value });
                                            }
                                        });

                                        //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                        options.unshift(allOpt);

                                        return options.map((option, index) => {
                                            return <option className={`${option.hidden ? "d-none" : ""}`} key={"assignsite" + index} value={option.value}>
                                                {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                {option.title}
                                            </option>
                                        });
                                    })()}
                                </Input>

                                {/* Service */}
                                <Label className="px-0 m-0 d-inline-block mx-2" for="selectService">{context.props.i18nManager.t("lead.svcSurveyFilter")}</Label>
                                <Input id={"selectService"} bsSize="sm" className={`w-auto d-inline-block me-2`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                    context.setState({ serviceFilter: parseInt(e.target.value), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                }} value={context.state.serviceFilter}>
                                    {(() => {
                                        //var allOpt = { selected: true, title: "Tous", value: -1 };
                                        var options = [];
                                        var values = {};
                                        context.services?.forEach((row) => {
                                            var label = row.name;
                                            var value = row.idService;
                                            if (value && label && !values[value]) {
                                                values[value] = value;
                                                options.push({ title: label, value: value });
                                            }
                                        });
                                        //options.unshift(allOpt);
                                        return options.map((option, index) => (
                                            <option key={"service" + index} value={option.value}>{option.title}</option>
                                        ));
                                    })()}
                                </Input>

                                {!groupLocked ? <FilesCustom className="generateDlg-files" title={context.props.i18nManager.t("gal_attachedFiles")} bindID={0} checkRights={this.props.checkRights} fileTypeID={"LEAD"} src={null} srcName={""}
                                    files={[]} setFiles={(compFiles) => {
                                        if (compFiles?.length) {
                                            var surveyLead = {
                                                idLead: 0, addressID: 0, address: { title: "Adresse", categ: "SITE", addressMain: "N/A", pc: 0 }, statusID: 3001, title: "Import Enquête", comments: "Import Enquête",
                                                email: "nomail@softena.com", groupID: (context.state.groupFilter || null), serviceID: (context.state.serviceFilter || -1), categoryID: importCategIDSurvey, assignSiteID: (context.state.assignSiteFilter || null)
                                            };
                                            surveyLead.localFiles = [...compFiles];
                                            surveyLead.cNoSwalMode = true;
                                            var callback = (leadResponse) => {
                                                //context.loadLead(leadResponse.result.idLead);
                                                if (leadResponse.isSuccess) {
                                                    var altProcessArgs = {};
                                                    altProcessArgs.entities = [{ id: leadResponse.result.idLead, tag: "", value: "" }];
                                                    altProcessArgs.categ = "IMPORT_SURVEY";
                                                    altProcessArgs.waitForCompletion = true;
                                                    commonFunc.postMethod("../api/lead/RunCustomsListJob", altProcessArgs).then((response) => {
                                                        Swal.close();
                                                        var data = response.data;
                                                        if (data?.isSuccess) {

                                                            Swal.fire({
                                                                icon: "success",
                                                                title: context.props.i18nManager.t("gal_success"),
                                                                html: "Traitement effectué avec succès",
                                                                didOpen: () => { Swal.hideLoading() },
                                                                allowOutsideClick: false,
                                                                allowEscapeKey: false,
                                                                allowEnterKey: false
                                                            }).then((result) => {
                                                                context.getLeads();
                                                            });

                                                        } else {
                                                            //Error Job
                                                            Swal.fire({
                                                                icon: "error",
                                                                title: context.props.i18nManager.t("gal_error"),
                                                                html: "Erreur lors du traitement :<br>" + data?.errorMessage
                                                            });
                                                            context.getLeads();
                                                        }
                                                    });
                                                }
                                            };

                                            return saveLead(surveyLead, {}, false, context.props.i18nManager, callback);

                                            /*if (element.argumentsObj?.fullFiles) {
                                                element.files = compFiles;
                                                //compFiles = [];
                                                parentElemProps.parentData.functionManager.rerender();
                                            }
                                            else {
                                                element.files = [];
                                                compFiles = [];
                                            }*/
                                        }
                                    }} altFilesTypes="../api/lead/GetLeadFilesType" altUploadFilesUrl="../api/lead/UploadLeadFiles" accept={{ "application/pdf": [".pdf"] }} noChooseTypes={true} minFiles={1} uploadAutoClose={true} resetAfterUpload={true}
                                    btnAddFilesLabel={context.props.i18nManager.t("lead.surveyAddFiles")} btnAddFilesColor="info" btnAddFilesIcon="fa-upload"
                                    noUploads={true} onlyUpload={true} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={"ISV"} maxFiles={1} /> : ""}

                                {pageConfig?.templates?.map((template, index) => {
                                    if (!groupLocked && template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                        switch (template.subType) {
                                            case "ADD":
                                                return <Button key={"addbtn"} className="btn-magnify px-2 mt-0 mb-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateLead()}>
                                                    <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("lead.surveyAdd")}
                                                </Button>;
                                            case "DIALOGADD":
                                                var saveCb = (leadResponse) => {
                                                    //context.loadLead(leadResponse.result.idLead);
                                                    context.getLeads();
                                                };

                                                return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0 mb-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                    <i className="fa fa-user-plus"></i>{context.props.i18nManager.t("lead.surveyAdd")}
                                                </Button>;
                                            default: return "";
                                        }
                                    }
                                    else return "";
                                })}
                            </div>
                            <div className="w-auto p-0 float-end">
                                {surveyGlobalStats ? <div className="d-inline-block me-2">{surveyGlobalStats?.count} enquêtes</div> : ""}
                                <Button className="btn-sm btn-magnify px-2" disabled={this.state.editionMode} color="info" onClick={() => {
                                    if (context.statsRef?.current) context.statsRef.current.displayStats();
                                    setTimeout(() => { context.setState({ rerender: !this.state.rerender }) }, 500);
                                }}>
                                    <i className="fa fa-chart-line me-1"></i>Résultats enquêtes
                                </Button>
                            </div>
                        </CardBody>
                    </Card>


                    <StatsLead ref={context.statsRef} i18nManager={context.props.i18nManager} parentContext={context} hideToolbarDate filters={{ groupFilter: context.state.groupFilter, assignSiteFilter: context.state.assignSiteFilter, serviceFilter: context.state.serviceFilter, categoryGroupKey: context.state.pageModels }}
                        leadModels={this.leadModels} {...context.leadModels["SURVEY_STATS_CFG"]} />


                    {<div className={`${context.statsRef?.current?.isDisplayStats() ? "d-none" : ""}`}>
                        {/* Compteur */}
                        <span className={`survey-results-count ${context.state.editionMode ? "d-none2" : ""}`}>
                            <strong>{filteredLeads.length}</strong> élément(s)
                            {(validLeads.length - filteredLeads.length) > 0 && ` (filtré de ${validLeads.length} au total)`}
                        </span>
                        <span className={`survey-results-count ${context.state.editionMode ? "d-none" : ""}`}>
                            - Enquete {filteredLeads.length ? this.state.currentPage : 0} sur {filteredLeads.length}
                        </span>

                        {this.state.isShowDetails && leadModel ? (<div className="detailsContainer">
                            <Card className="widget dash text-white d-none" color="theme">
                                <CardHeader>
                                    <Row>
                                        <Col lg="10" className="offset-lg-1">
                                            <CardTitle tag="h6" className="text-center">
                                                {this.state.title}
                                            </CardTitle>
                                        </Col>
                                        <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                            <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                                var prevId = context.state.curLeadId || 0;
                                                showDtPrevID("tableLeads", prevId);
                                            }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                            <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                                var prevId = context.state.curLeadId || 0;
                                                showDtNextID("tableLeads", prevId);
                                            }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                        {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                                    </Nav>
                                </CardBody>
                            </Card>
                            <TabContent activeTab={this.state.activeTab}>
                                <div className={`${context.state.editionMode ? "d-none" : ""}`}>
                                    {(() => {
                                        var pagesList = [];
                                        var maxPages = filteredLeads.length;
                                        if (maxPages > 1) {
                                            pagesList.push(1);
                                            var currChildCount = 1;
                                            var countPage = 3;
                                            var currCountPage = 3;
                                            var appendEnd = false;
                                            var minPage = (context.state.currentPage - (countPage - currChildCount)) > 1 ? (context.state.currentPage - (countPage - currChildCount)) : 2;
                                            if (minPage > 2 && maxPages > countPage + (currChildCount + 1)) {
                                                pagesList.push("...");
                                                currCountPage--;
                                                minPage++;
                                            }
                                            if (minPage > (maxPages - countPage - 1) && (maxPages - ((currChildCount * 2) + 2)) > 0) minPage = (maxPages - ((currChildCount * 2) + 2));
                                            if (minPage <= 1) minPage = 2;
                                            if (minPage <= maxPages) {
                                                var currMaxPage;
                                                if ((minPage + countPage + 2) > maxPages) {
                                                    currMaxPage = (maxPages > 2 ? maxPages - 1 : maxPages);
                                                }
                                                else {
                                                    currMaxPage = (minPage + currCountPage);
                                                    currCountPage--;
                                                    appendEnd = true;
                                                }
                                                for (var i = minPage; i <= currMaxPage; i++) {
                                                    pagesList.push(i);
                                                }
                                                if (appendEnd) pagesList.push("...");
                                            }
                                            if (maxPages > currMaxPage) pagesList.push(maxPages);
                                        }
                                        return pagesList.length ? <>
                                            <Button className={`btn-icon btn-round ${(context.state.currentPage - 1) < 1 ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { context.setState({ currentPage: context.state.currentPage - 1, curLeadId: 0, curLead: null, isShowDetails: false }); }}><i className="fa fa-chevron-left"></i></Button>
                                            {pagesList.map(i => <Button key={"pageBtn" + i} className={`btn-icon btn-round ${i === "..." ? "disabled" : ""}`} size="sm" color={i === context.state.currentPage ? "primary" : "secondary"} onClick={(e) => { if (context.state.currentPage !== i) context.setState({ currentPage: i, curLeadId: 0, curLead: null, isShowDetails: false }); }}>{i}</Button>)}
                                            <Button className={`btn-icon btn-round ${(context.state.currentPage + 1) > maxPages ? "disabled" : ""}`} size="sm" color="secondary" onClick={(e) => { context.setState({ currentPage: context.state.currentPage + 1, curLeadId: 0, curLead: null, isShowDetails: false }); }}><i className="fa fa-chevron-right"></i></Button>
                                        </> : "";
                                    })()}
                                </div>

                                <ShowDetails id={this.state.curLeadId} type="lead" genRef={this.leadGen} data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={leadModel} modelsList={this.leadModels}
                                    loadElem={this.loadLead.bind(this)} saveElem={this.contextSaveLead.bind(this)} removeElem={this.removeLead.bind(this)} updateStatusElem={this.updateLeadStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === "1"}
                                    dialogShowLead={() => { dialogAltLead(context.props.i18nManager.t("lead.tabDetails"), "DLG_LEAD", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                                    dialogEditLead={() => { showDialogLead(altT(templatesWidgetList[0].name), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                                    dialogDuplicateLead={() => { showDialogLead(altT(templatesWidgetList[0].name.replace("edit", "duplicate")), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager, true); }}
                                    manageEmail={() => { sendEmailDialog(this.state.curLead, context.props.dataCfg, context.props.i18nManager); }}
                                    manageRecapEmail={() => { sendRecapEmailDialog(this.state.curLead, context.props.dataCfg, context.props.i18nManager); }}
                                    dialogLossLead={() => { dialogAltLead(context.props.i18nManager.t("lead.leadloss"), "LEADLOSS", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                                    dialogScheduleVisit={() => { dialogAltLead(context.props.i18nManager.t("lead.scheduleVisit"), "SCHEDULEVISIT", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}
                                    manageShopOrder={() => { context.manageShopOrder(this.state.curLead, context) }}
                                    generateLeadRecap={() => { context.generateLeadRecap(this.state.curLead) }}
                                    newRecall={() => { context.newRecall(this.state.curLead) }} />
                            </TabContent>
                        </div>) : ""}
                    </div>}
                </div>
            );
        }
        else {
            let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                <div>
                    {this.leadModels ? <CDataTable key="leads" dtId={"tableLeads"} data={filteredLeads} localConfig={dtConfig} tag={tableConfig} config={this.leadModels[tableConfig]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                        className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} attrSup={{ "dt-filter-target": ("tableLeads_filters") }} /> : ""}
                </div>;


            var currentGroupFiltered = context.groups?.filter(grp => grp.idSegment === context.state.groupFilter);
            var groupTableLocked = false;

            return (
                <div className="tableDetails">
                    <div className="tableContainerBis">
                        <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t(context.state.pageModels === "SURVEY" ? "lead.surveyTitle" : "lead.title")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-table-list fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <div className="float-start">
                                    {context.state.switchDisplay ? <Button className="btn-icon btn-round mt-0" color="primary" onClick={() => {
                                        var supStates = {};
                                        if (context.state.pageModels !== "SURVEY") {
                                            supStates.serviceFilter = -1;
                                        }
                                        else supStates.serviceFilter = context.services?.length ? context.services[0].idService : -1;
                                        context.setState({ leads: [], switchDisplay: !context.state.switchDisplay, searchField: "", onlyActives: (isProjectPage || context.state.curStatus === 3000), dataStamp: new Date().getTime(), ...supStates });
                                    }}><i className="fa fa-columns"></i></Button> : ""}
                                    <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getLeads()}>
                                        <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                    </Button>
                                    {pageConfig?.templates?.map((template, index) => {
                                        if (context.state.pageModels !== "SURVEY" && template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                            switch (template.subType) {
                                                case "ADD":
                                                    return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateLead()}>
                                                        <i className="fa fa-plus-square"></i>{context.props.i18nManager.t(context.state.pageModels === "SURVEY" ? "lead.surveyAdd" : "lead.add")}
                                                    </Button>;
                                                case "DIALOGADD":
                                                    var saveCb = (leadResponse) => {
                                                        //context.loadLead(leadResponse.result.idLead);
                                                        context.getLeads();
                                                    };

                                                    return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                        <i className="fa fa-user-plus"></i>{context.props.i18nManager.t("lead.add")}
                                                    </Button>;
                                                default: return "";
                                            }
                                        }
                                        else return "";
                                    })}
                                </div>
                                {context.state.pageModels !== "SURVEY" && <CNavbar className="float-end">
                                    <div className="text-end">
                                        {this.state.status.map((dt) => {

                                            //TODO : statusBtnAltProc

                                            var statusClass = "form-badge-radio mb-1 ";
                                            statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                            return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                                <div className='form-check-radio fcheck-sm mb-0'>
                                                    <Label check >
                                                        <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                            var value = parseInt(e.target.value);

                                                            context.setState({ curStatus: value, curLeadId: 0, curLead: null, isShowDetails: false });
                                                        }} />
                                                        <span className="form-check-sign" />
                                                        {(() => {
                                                            var classFa = "";
                                                            if (dt.css && dt.css.indexOf("fa-")) {
                                                                dt.css.split(" ").forEach((classElem) => {
                                                                    //console.debug(classElem.startsWith("fa-") + classElem);
                                                                    classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                                });
                                                            }
                                                            return <i className={`fa ${classFa} me-1`}></i>
                                                        })()}
                                                        {altT(dt.name)}
                                                    </Label>
                                                </div>
                                            </div> : "";
                                        })}
                                    </div>
                                </CNavbar>}
                                <div id={"tableLeads_filters"} className="d-none w-auto p-0">
                                    {context.state.altMode && <div className="d-inline-block">
                                        <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSiteT"}>{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                        <Input id={"selectAssignSiteT"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                            var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                            var curFilter = selValue;
                                            context.setState({ assignSiteFilter: parseInt(curFilter), dataStamp: new Date().getTime() });
                                        }} value={context.state.assignSiteFilter}>
                                            {(() => {
                                                var allOpt = { selected: true, title: "Tous", value: -1 };
                                                var options = [];

                                                var values = {};
                                                validLeads.forEach((row) => {
                                                    var label = row.extSite?.name;
                                                    var value = row.assignSiteID;
                                                    if (value && label && !values[value]) {
                                                        values[value] = value;
                                                        options.push({ title: label, value: value });
                                                    }
                                                });

                                                options = options.sort((a, b) => a.title.localeCompare(b.title));
                                                options.unshift(allOpt);

                                                return options.map((option, index) => {
                                                    return <option className={`${option.hidden ? "d-none" : ""}`} key={"site" + index} value={option.value}>
                                                        {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                        {option.title}
                                                    </option>
                                                });
                                            })()}
                                        </Input>
                                    </div>}
                                    {context.state.pageModels === "SURVEY" && <>
                                        {/* Type Enquête */}
                                        <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectGroup"}>{context.props.i18nManager.t("lead.groupSurveyFilter")}</Label>
                                        <Input id={"selectGroup"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "250px" }} onChange={(e) => {
                                            context.setState({ groupFilter: parseInt(e.target.value), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                        }} value={context.state.groupFilter}>
                                            {(() => {
                                                //var allOpt = { selected: true, title: "Tous", value: -1 };
                                                var options = [];

                                                var values = {};
                                                context.groups?.forEach((row) => {
                                                    var label = row.title;
                                                    var value = row.idSegment;
                                                    if (value && label && !values[value]) {
                                                        values[value] = value;
                                                        options.push({ title: label, value: value });
                                                    }
                                                });

                                                //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                                //options.unshift(allOpt);

                                                return options.map((option, index) => {
                                                    return <option className={`${option.hidden ? "d-none" : ""}`} key={"group" + index} value={option.value}>
                                                        {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                        {option.title}
                                                    </option>
                                                });
                                            })()}
                                        </Input>

                                        {/* Asso. */}
                                        <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSiteT"}>{context.props.i18nManager.t("lead.siteSurveyFilter")}</Label>
                                        <Input id={"selectAssignSiteT"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                            var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                            var curFilter = selValue;
                                            context.setState({ assignSiteFilter: parseInt(curFilter), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                        }} value={context.state.assignSiteFilter}>
                                            {(() => {
                                                var allOpt = { selected: true, title: "Tous", value: -1 };
                                                var options = [];

                                                var values = {};
                                                context.sites?.forEach((row) => {
                                                    var label = row.name;
                                                    var value = row.idSite;
                                                    if (value && label && !values[value]) {
                                                        values[value] = value;
                                                        options.push({ title: label, value: value });
                                                    }
                                                });

                                                //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                                if (context.state.pageModels === "SURVEY") options.unshift(allOpt);

                                                return options.map((option, index) => {
                                                    return <option className={`${option.hidden ? "d-none" : ""}`} key={"assignsite" + index} value={option.value}>
                                                        {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                        {option.title}
                                                    </option>
                                                });
                                            })()}
                                        </Input>

                                        {/* Service */}
                                        <Label className="px-0 m-0 d-inline-block mx-2" for="selectService">{context.props.i18nManager.t("lead.svcSurveyFilter")}</Label>
                                        <Input id={"selectService"} bsSize="sm" className={`w-auto d-inline-block me-2`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                            context.setState({ serviceFilter: parseInt(e.target.value), currentPage: 1, curLeadId: 0, curLead: null, isShowDetails: false });
                                        }} value={context.state.serviceFilter}>
                                            {(() => {
                                                var allOpt = { selected: true, title: "Tous", value: -1 };
                                                var options = [];
                                                var values = {};
                                                context.services?.forEach((row) => {
                                                    var label = row.name;
                                                    var value = row.idService;
                                                    if (value && label && !values[value]) {
                                                        values[value] = value;
                                                        options.push({ title: label, value: value });
                                                    }
                                                });
                                                if (context.state.pageModels === "SURVEY") options.unshift(allOpt);
                                                return options.map((option, index) => (
                                                    <option key={"service" + index} value={option.value}>{option.title}</option>
                                                ));
                                            })()}
                                        </Input>
                                    </>}
                                </div>
                                {contents}
                            </CardBody>
                        </Card>
                    </div>
                    {this.state.isShowDetails ? (<div className={`detailsContainer ${groupTableLocked ? "form-locked" : ""}`}>
                        <Card className="widget dash text-white" color="theme">
                            <CardHeader>
                                <Row>
                                    <Col lg="10" className="offset-lg-1">
                                        <CardTitle tag="h6" className="text-center">
                                            {this.state.title}
                                        </CardTitle>
                                    </Col>
                                    <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curLeadId || 0;
                                            showDtPrevID("tableLeads", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curLeadId || 0;
                                            showDtNextID("tableLeads", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                    {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                                </Nav>
                            </CardBody>
                        </Card>
                        <TabContent activeTab={this.state.activeTab}>
                            {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? getSysCpt(template, index + 1) : "")}
                        </TabContent></div>) : ""}
                </div>
            );
        }
    }

    async getLeads(statusId, forcedUpdate, callback, preventChildLoad, withRecommandations) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ leads: [], curLeadId: 0, curLead: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false, currentPage: 1 });//Si on ne reset pas currentPage, attention aux récupérations de nouveaux éléments ou de suppression
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus;
        args.modelLLM = "gpt-51";//GetLeadsWithRecommandations


        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        var isProjectPage = (context.state.pageModels === "PROJECTLEAD" || context.state.pageModels === "PTECHLEAD");

        if (context.state.altMode) {
            args.level = 3;
            if (context.state.onlyActives) args.state = (isProjectPage ? 4 : 5);
            else if (isProjectPage && (!context.state.switchDisplay || statusId === 3000)) {
                args.state = 3000;
            }
            else {
                args.state = context.state.curStatus;
            }
        }

        if (context.state.pageModels === "SURVEY") {
            args.level = context.state.switchDisplay ? 3 : null;
            args.assignSiteID = context.state.assignSiteFilter;
        }

        commonFunc.getMethod((withRecommandations /*&& context.props.getUser().id !== 254*/) ? "../api/lead/GetLeadsWithRecommandations" : "../api/lead/GetLeads", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();

                    var results = (response.data.result || []);
                    if (context.state.pageModels === "SURVEY") {
                        //results.sort((b, a) => { return new Date(a.dSysMod).getTime() - new Date(b.dSysMod).getTime(); });
                        var filteredLeads = results.filter(lead => {
                            //if (context.state.assignSiteFilter > 0 && lead.assignSiteID !== context.state.assignSiteFilter) return false;
                            if (context.state.serviceFilter > 0 && lead.serviceID !== context.state.serviceFilter) return false;
                            if (context.state.groupFilter > 0 && lead.groupID !== context.state.groupFilter) return false;
                            if ((lead.categoryID !== 5 && !(lead.parentID > 0))) return false;
                            return !(lead.idLead <= 0);
                        });
                        if (filteredLeads.length) {
                            if (!preventChildLoad) {
                                context.setState({ leads: results, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });

                                var selLeadID = filteredLeads[this.state.currentPage - 1].idLead;
                                if (context.state.curLeadId) {
                                    var selectedLead = filteredLeads.filter(lead => lead.idLead === context.state.curLeadId);
                                    if (selectedLead.length) selLeadID = context.state.curLeadId;
                                }
                                if (!context.state.switchDisplay) context.loadLead(selLeadID);
                                return;
                            }
                            else {
                                context.refreshCb = null;
                                if (callback && typeof (callback) === "function") { callback(); }
                            }
                        }
                    }
                    else if (!context.state.switchDisplay && isProjectPage) {
                        if (context.state.pageModels === "PROJECTLEAD") {//Alternative : vue qu'on a besoin de 2 groupKey, filtre local..
                            results = results.filter(lead => lead.category?.groupKey === "PROJECT" || lead.category?.groupKey === "VERSION");
                        }
                        else {
                            results = results.filter(lead => lead.category?.groupKey === "PTECH" || lead.category?.groupKey === "VTECH");
                        }
                        var isProjectTech = (context.state.pageModels === "PTECHLEAD");

                        results.sort((b, a) => { return new Date(a.dSysMod).getTime() - new Date(b.dSysMod).getTime(); });
                        var groupedProject = results.filter(lead => lead.parentID <= 0);
                        var groupedPerson = results.filter(lead => lead.parentID > 0 && lead.recall === 1).map(clone => Object.assign({}, clone));
                        groupedPerson.forEach(person => {
                            var parentProject = groupedProject.filter(project => project.idLead === person.parentID);
                            if (parentProject?.length && ((!parentProject[0].persons?.length || !parentProject[0].persons?.filter(item => item.clientID === person.clientID && (!isProjectTech || item.serviceID === person.serviceID))?.length))) {
                                if (!parentProject[0].persons) parentProject[0].persons = [];
                                parentProject[0].persons.push(person);
                            }
                        });
                        results.forEach(lead => {
                            if (lead.parentID > 0) {
                                var parentProject = groupedProject.filter(project => project.idLead === lead.parentID);
                                if (parentProject?.length && parentProject[0].persons?.length) {
                                    var personContainer = parentProject[0].persons.filter(person => person.clientID === lead.clientID && (!isProjectTech || person.serviceID === lead.serviceID));
                                    if (personContainer?.length) {
                                        if (!personContainer[0].versions) personContainer[0].versions = [];
                                        personContainer[0].versions.push(lead);

                                        if (personContainer[0].hasAct) {
                                            if ((lead.serviceID === 801 || lead.serviceID === 901) && lead.recall > personContainer[0].recall) {
                                                personContainer[0].groupID = lead.groupID;
                                                personContainer[0].group = lead.group;
                                                personContainer[0].recall = lead.recall;
                                            }
                                        }
                                        else {
                                            if (lead.serviceID === 801 || lead.serviceID === 901) {
                                                personContainer[0].hasAct = true;
                                                personContainer[0].serviceID = lead.serviceID;
                                                personContainer[0].service = lead.service;
                                                personContainer[0].groupID = lead.groupID;
                                                personContainer[0].group = lead.group;
                                                personContainer[0].recall = lead.recall;
                                            }
                                            else if (lead.recall > personContainer[0].recall) {
                                                personContainer[0].groupID = lead.groupID;
                                                personContainer[0].group = lead.group;
                                                personContainer[0].recall = lead.recall;
                                            }
                                        }
                                    }
                                }
                            }
                        });
                        results = groupedProject;
                    }
                    else results.sort((b, a) => { return new Date(a.dSysMod).getTime() - new Date(b.dSysMod).getTime(); });

                    var supStates = {};
                    if (response.data.extraInfo?.recommandations?.length) {
                        supStates.recommandations = response.data.extraInfo.recommandations;
                        supStates.recommandations = supStates.recommandations.filter(reco => {
                            var leadSrc = results.filter(lead => lead.idLead === reco.leadId);
                            if (leadSrc.length) {
                                reco.title = leadSrc[0].client?.name.toUpperCase() + " " + commonFunc.capitalize(leadSrc[0].client?.firstName);
                                if (!reco.hasRecommendation || (reco.reason === "Aucune visite planifiée" && leadSrc[0].serviceID !== 801)) return false;
                                else leadSrc[0].cRecommandation = reco;
                            }
                            return true;
                        }).sort((a, b) => b.slaHours - a.slaHours);
                    }
                    context.setState({ leads: results, loading: false, dataStamp: new Date().getTime(), isShowDetails: false, ...supStates });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("lead.failLoadLeads") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("lead.failLoadLeads")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/lead/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadLead(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("lead.noSelected"), curLeadId: 0, curLead: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;

            if (context.state.altMode) {
                args.level = 3;
            }
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                commonFunc.getMethod("../api/lead/GetLead", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        const importCategIDSurvey = 6;
                        if (context.state.pageModels === "SURVEY" && data.result.categoryID === importCategIDSurvey) {

                            commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: data.result.parentID }).then((responseFiles) => {

                            });

                            //Récupérations images parent import
                            commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: data.result.parentID }).then((responseFiles) => {
                                var dataFiles = responseFiles.data;
                                if (dataFiles.isSuccess) {
                                    Swal.close();
                                    var targetFiles = dataFiles.result.filter(file => file.name.startsWith(data.result.parentID + "_" + data.result.recall + "_"));
                                    if (targetFiles.length) {
                                        var dt = targetFiles[0];
                                        var file = {
                                            fileId: dt.idFile,
                                            fileName: dt.name,
                                            container: dt.rootContainer,
                                            etag: dt.etag,
                                            accessToken: dt.absoluteUri,
                                            newWindow: false
                                        };
                                        var filePath = "../api/data/DownloadFileByUri?" + commonFunc.toParams(file);
                                        data.result.cImportPic1 = filePath;
                                        if (targetFiles.length > 1) {
                                            dt = targetFiles[1];
                                            file = {
                                                fileId: dt.idFile,
                                                fileName: dt.name,
                                                container: dt.rootContainer,
                                                etag: dt.etag,
                                                accessToken: dt.absoluteUri,
                                                newWindow: false
                                            };
                                            filePath = "../api/data/DownloadFileByUri?" + commonFunc.toParams(file);
                                            data.result.cImportPic2 = filePath;
                                        }
                                    }
                                }
                                else {
                                    Swal.close();
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_error"),
                                        html: "Aucun fichier trouvé"
                                    });
                                }

                                if (callback && typeof (callback) === "function") { callback(data); }
                                if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.title + " • " + data.result.address.city), curLeadId: id, curLead: data.result, isShowDetails: true });

                                resolve(data);
                            });
                        }
                        else {
                            if (callback && typeof (callback) === "function") { callback(data); }

                            Swal.close();

                            if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.title + " • " + data.result.address.city), curLeadId: id, curLead: data.result, isShowDetails: true });

                            resolve(data);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("lead.failLoadLead") + " :<br>" + data.errorMessage
                        });
                        resolve(data);
                    }
                });

            }
            else {
                if (context.state.pageModels === "SURVEY" && !context.state.switchDisplay) context.getLeads(null, true);
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveLead(userLead, isUpdate) {
        var context = this;
        var callback;

        if (context.state.pageModels === "SURVEY") {
            callback = (leadResponse) => {
                if (leadResponse.isSuccess) {
                    if (!isUpdate && userLead.cMultipleMode === "true") {
                        context.getLeads(null, true, () => {
                            context.initCreateLead();
                        }, true);
                    }
                    else context.getLeads(null, true);
                }
                else {
                    context.getLeads(null, true);
                }
            };

            if (!userLead.assignSiteID && context.state.assignSiteFilter) userLead.assignSiteID = context.state.assignSiteFilter;
            if (!userLead.serviceFilter && context.state.serviceFilter) userLead.serviceID = context.state.serviceFilter;
            if (!userLead.groupID && context.state.groupFilter) userLead.groupID = context.state.groupFilter;

            userLead.cToastMode = true;
        }
        else {
            callback = (leadResponse) => {
                context.loadLead(leadResponse.result.idLead);
            };
        }

        return saveLead(userLead, context.state.curLead, isUpdate, context.props.i18nManager, callback);
    }

    removeLead(id, title, altLabel) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curLead;
            if ((!id && row) || (id && row && id === row.idLead)) {
                id = id || row.idLead;
                title = row.title;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t(altLabel || "lead.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("lead.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        if (context.state.pageModels === "SURVEY") {
                            //req.isPermanent = true;
                            req.byStatus = false;
                        }
                        commonFunc.postMethod("../api/lead/RemoveLead", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getLeads();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateLeadStatus(statusId, stepId, customLabel, overrideLeadID, noSwal, noRefresh, newRecall) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = overrideLeadID || context.state.curLeadId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadLead = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");

                    var processStatus = () => {
                        if (!noSwal) {
                            Swal.fire({
                                title: context.props.i18nManager.t("lead.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                        }
                        var req = { id: id, newStatus: statusId, newStep: stepId || -1 };
                        if (newRecall) req.recall = newRecall;

                        commonFunc.postMethod("../api/lead/UpdateStatus", req).then((response) => {

                            Swal.close();
                            if (response.data && response.data.isSuccess) {
                                /*context.getLeads(0, true, () => {
                                    if (reloadLead) showDtSelID("tableLeads", id);
                                });*///TODO : check si besoin de refresh supplémentaire
                                if (!noRefresh) {
                                    if (overrideLeadID) context.getLeads();
                                    else {
                                        if (reloadLead) context.loadLead(id);
                                    }
                                }
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(response.data);
                        });
                    };

                    if (noSwal) {
                        processStatus();
                    }
                    else {
                        Swal.fire({
                            icon: "question",
                            title: context.props.i18nManager.t("lead.updStatus"),
                            html: context.props.i18nManager.t("lead.statusAs", [label]),
                            showCancelButton: true,
                            confirmButtonColor: "#28a745",
                            cancelButtonColor: "#dc3545",
                            confirmButtonText: context.props.i18nManager.t("gal_yes"),
                            cancelButtonText: context.props.i18nManager.t("gal_no"),
                        }).then((result) => {
                            if (result.value) {
                                processStatus();
                            }
                            else {
                                resolve({ isSuccess: true, result: "" });
                            }
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    manageShopOrder(lead, context) {
        Swal.fire({
            title: "Génération tarifs en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var id = lead.idLead;

        var req = { id: id, waitForCompletion: true/*, templateID: -1, useCascade: false*/ };
        commonFunc.postMethod("../api/lead/GenerateShopOrder", req).then((response) => {
            var data = response.data;
            if (data && data.isSuccess && data.extraInfo) {
                commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: id, fileId: data.extraInfo.idFile }).then((response) => {
                    Swal.close();
                    var dataFile = response.data;
                    if (dataFile && dataFile.isSuccess && dataFile.result?.length) {
                        var dt = dataFile.result[0];
                        const file = {
                            fileId: dt.idFile,
                            fileName: dt.name,
                            container: dt.rootContainer,
                            etag: dt.etag,
                            accessToken: dt.absoluteUri,
                            newWindow: false
                        };
                        var filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);

                        var callbackModal = function (data) {
                            console.debug(data);

                            if (data) {
                                context.modalRoot.unmount();
                            }
                            else {
                                context.modalRoot.unmount();
                            }

                            context.getLeads(3000, true, () => {
                                //showDtSelID("tableLeads", data.result.idLead);
                            });
                        };

                        context.modalRoot = createRoot(document.createElement('div'));
                        context.modalRoot.render(<PreviewModal parentContext={this} lead={lead} title={"Aperçu Tarifs"} url={filePath} successBtnCb={() => { context.modalRoot.unmount(); context.updateLeadStatus(3003, -1, "Envoi des tarifs", id); }} callback={callbackModal}></PreviewModal>);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: "Echec de récupération du fichier tarifs<p>" + response.data.errorMessage + "</p>",
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: "Echec de la génération des tarifs<p>" + response.data.errorMessage + "</p>",
                });
            }
        });
    }

    showFlows(idElem, rowData) {
        var context = this;

        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }

        if (parseInt(idElem) > 0) {
            //Traitement des informations retourné par le Dialog
            var callbackModal = function (dataElem, isUpdate) {
                context.modalRoot.unmount();
            };

            context.modalRoot = createRoot(document.createElement('div'));
            context.modalRoot.render(<FlowsModal t={context.props.i18nManager.t} rowData={rowData} dataFlows={rowData.flows} title={context.props.i18nManager.t("lead.tabFlows")} idElem={idElem} parentContext={context} callback={callbackModal} />);

        }
        else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_error"),
                html: context.props.i18nManager.t("gal_invalidID")
            });
        }
    }

    generateLeadRecap(lead, modelExtID) {
        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        var req = { id: lead.idLead, modelExtID: (modelExtID || "PREVIEW-NONE-184519567-1"), waitForCompletion: true, fileExtension: { id: 30, tag: "RCP", value: "Récap" } };//UseAI/UseCascade
        return commonFunc.postMethod("../api/lead/GenerateLeadFile", req).then((response) => {
            context.reloadFiles(context, response, lead);
        });
    }

    launchFileAction(file, lead, modelExtID) {
        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        //file.categ
        var req = { id: file.idFile, bindID: lead.idLead, modelExtID: (modelExtID || "PREVIEW-NONE-184519567-1"), waitForCompletion: true, fileExtension: { id: 30, tag: "RCP", value: "Récap" } };//UseAI/UseCascade
        return commonFunc.postMethod("../api/lead/LaunchLeadFile", req).then((response) => {
            context.reloadFiles(context, response, lead);
        });
    }

    launchGroupFileAction(key, files, lead, modelExtID, isCategGroupment) {
        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        var supArgs = (isCategGroupment ? { filteredCateg: [key] } : { filteredLots: [parseInt(key)] });

        var req = { ...supArgs, id: lead.idLead, modelExtID: (modelExtID || "PREVIEW-NONE-184519567-1"), waitForCompletion: true, fileExtension: { id: 30, tag: "RCP", value: "Récap" } };//UseAI/UseCascade
        return commonFunc.postMethod("../api/lead/GenerateLeadFileNEW", req).then((response) => {
            context.reloadFiles(context, response, lead);
        });
    }

    reloadFiles(context, response, lead) {
        var data = response.data;
        if (data && data.isSuccess && data.result) {
            commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: lead.idLead, fileId: data.result.idFile }).then((response) => {
                Swal.close();
                var dataFile = response.data;
                if (dataFile && dataFile.isSuccess && dataFile.result?.length) {
                    var dt = dataFile.result[0];
                    const file = {
                        fileId: dt.idFile,
                        fileName: dt.name,
                        container: dt.rootContainer,
                        etag: dt.etag,
                        accessToken: dt.absoluteUri,
                        newWindow: false
                    };
                    var filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);

                    var callbackModal = function (data) {
                        console.debug(data);

                        if (data) {
                            context.modalRoot.unmount();
                        }
                        else {
                            context.modalRoot.unmount();
                        }

                        context.getLeads(3000, true, () => {
                            //showDtSelID("tableLeads", data.result.idLead);
                        });
                    };

                    context.modalRoot = createRoot(document.createElement('div'));
                    context.modalRoot.render(<PreviewModal parentContext={this} hideEmail lead={lead} title={"Aperçu Récap."} url={filePath} callback={callbackModal}></PreviewModal>);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: "Echec de récupération du fichier récap.<p>" + response.data.errorMessage + "</p>",
                    });
                }
            });
        } else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_fail"),
                html: "Echec de la génération du récap.<p>" + response.data.errorMessage + "</p>",
            });
        }
    }



    newRecall(lead) {
        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        var subStatus;
        commonFunc.getMethod("../api/lead/GetStatus", { isSubStatus: true }).then((response) => {
            Swal.close();
            var data = response.data;
            if (data.isSuccess) {
                subStatus = data.result;
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

            var stepStatus = subStatus?.filter(status => status.categ === "SLEAD" && status.step === 2).sort((a, b) => a.idStatus - b.idStatus);
            var recallOptions = stepStatus?.length ? ("<select id='swal2-input' class='swal2-input' style='display: flex;'>" + stepStatus.map(status => `<option ${lead.stepID === status.idStatus ? "selected" : ""} value='${status.idStatus}'>${status.name}</option>`).join() + "</select>") : "";

            Swal.fire({
                icon: "question",
                title: "Nouvelle Relance",
                html: "<label>Etes-vous sûr de vouloir augmenter le niveau de relance ?</label>" + recallOptions,
                customClass: "cswal-input",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: context.props.i18nManager.t("gal_yes"),
                cancelButtonText: context.props.i18nManager.t("gal_no"),
                didOpen: () => { Swal.hideLoading() },
            }).then((result) => {
                if (result.value) {
                    //if (!lead.recall || !parseInt(lead.recall)) lead.recall = 0;
                    //lead.recall += 1;
                    //context.contextSaveLead(lead, true);

                    var inputSwal = document.getElementById("swal2-input");
                    var stepID = inputSwal?.value;
                    var newRecallValue = lead.recall;
                    if (!newRecallValue || !parseInt(newRecallValue)) newRecallValue = 0;
                    context.updateLeadStatus(lead.statusID, stepID, null, lead.idLead, true, true, (newRecallValue + 1)).then((response) => {
                        if (response.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: context.props.i18nManager.t("gal_success"),
                                html: "Relance effectué avec succès",
                                didOpen: () => { Swal.hideLoading() },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then(() => {
                                //if (callback && typeof (callback) === "function") { callback(data); }
                                context.getLeads(3000, true, () => { });
                            });
                        }
                        else context.getLeads(3000, true, () => { });
                    });
                }
            });
        });
    }



    initCreateLead() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableLeads");
        //this.leadGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("lead.create"), curLeadId: 0, curLead: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;

        /*if (!numTab) {
            var tabIndex = 1;
            pageConfig.templates.forEach((template, index) => {
                if (template.subType === entity) tabIndex = index + 1;
            });
            numTab = tabIndex;
        }*/

        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curLead ? this.state.curLead.title : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("lead.duplicate") : this.props.i18nManager.t("lead.edit")) + " - " + title, editionMode: value });
    }
}

function prepareLead(userLead, dataLead, isUpdate) {
    if (isUpdate) {
        if (dataLead?.dSysCreat) userLead.dSysCreat = dataLead.dSysCreat;
    }
    else {
        userLead.dSysCreat = new Date();
    }

    var resetNestedFields = ["category", "site", "extraSite", "client", "status", "subStatus", "tenantUserAccess", "group", "service", "flows", "parent"];//userLead.allowNestedUpdate = ["client"];
    if (!userLead.avoidMerge) {
        userLead = commonFunc.mergeDeep({}, dataLead, userLead);

        resetNestedFields.forEach((resetField) => {
            if (!(userLead.allowNestedUpdate?.length && userLead.allowNestedUpdate.indexOf(resetField) >= 0)) {
                if (resetField === "flows") {
                    userLead.flows = [];
                }
                else userLead[resetField] = null;
            }
            //if (!isUpdate && resetField.startsWith("tenantUserAccess")) delete userLead[resetField];
        });

        //MAJ Client
        if (userLead.client && !userLead.client.avoidMerge) {
            userLead.client = commonFunc.mergeDeep({}, dataLead?.client, userLead.client);

            //userSite.contacts = null;
            //userSite.agreements = null;
            //userSite.clientFiles = null;
            //userSite.clientParents = null;
            //userSite.demands = null;
            //userSite.flows = null;
            //userSite.matchesAssigned = null;
            //userSite.models = null;
            userLead.client.accountUser = null;
            userLead.client.billingFirm = null;
            userLead.client.category = null;
            userLead.client.parent = null;
            userLead.client.group = null;
            userLead.client.site = null;
            userLead.client.extraSite = null;
            userLead.client.status = null;
            userLead.client.subStatus = null;
            userLead.client.tenantUserAccess = null;
        }
    }
    userLead.assignSite = null;
    userLead.extSite = null;
    /*if (!userLead.leadFiles)*/ userLead.leadFiles = [];

    //Reset Contacts
    if (!isUpdate && userLead.idLead === 0) {
        userLead.contacts = userLead.contacts?.filter(contact => contact?.idContact === 0) || [];
        if (userLead.client) userLead.client.contacts = userLead.client.contacts?.filter(contact => contact?.idContact === 0) || [];
    }

    if (userLead.contact?.name) {
        if (!userLead.contacts) userLead.contacts = [];
        if (!userLead.contact.idContact) userLead.contact.idContact = 0;
        var checkContact = userLead.contacts.filter(contact => contact?.idContact === userLead.contact.idContact);
        if (checkContact.length) checkContact[0] = commonFunc.mergeDeep(checkContact[0], userLead.contact);
        else userLead.contacts.push(userLead.contact);
    }
    if (userLead.client?.contacts) {
        userLead.client.contacts = userLead.client.contacts.filter(ctc => ctc != null);
        userLead.client.contacts.forEach((ctc, index) => {
            if (userLead.client?.contacts_temp?.length) {
                var foundedTempCtc = userLead.client?.contacts_temp?.filter(dCtc => dCtc?.idContact === ctc.idContact);
                if (foundedTempCtc?.length) {
                    if (foundedTempCtc[0].idContact) {
                        userLead.client.contacts[index] = commonFunc.mergeDeep({}, ctc, foundedTempCtc[0]);
                    }
                    else userLead.client.contacts[index] = commonFunc.mergeDeep({}, foundedTempCtc[0], ctc);
                }
            }

            var foundedCtc = dataLead?.client?.contacts?.filter(dCtc => dCtc?.idContact === ctc.idContact);
            if (foundedCtc?.length) {
                //ctc = commonFunc.mergeDeep({}, foundedCtc[0], ctc);
            }

            /*if (!ctc.address) {
                userLead.client.contacts[index].address = {
                    "addressMain": "N/A",
                    "categ": "SITE",
                    "title": "Adresse",
                    "avoidReset": "true",
                    "idAddress": ctc.addressID || 0
                };
            }*/
            //ctc.clientID = userLead.clientID;
            console.debug(ctc);
        });
    }
    if (userLead.client?.contact?.name) {
        if (!userLead.client.contacts) userLead.client.contacts = [];
        if (!userLead.client.contact.idContact) userLead.client.contact.idContact = 0;

        var checkContactClient = userLead.client.contacts.filter(contact => contact?.idContact === userLead.client.contact.idContact);
        if (checkContactClient.length) checkContactClient[0] = commonFunc.mergeDeep(checkContactClient[0], userLead.client.contact);
        else userLead.client.contacts.push(userLead.client.contact);

        if (userLead.client.contact.idContact <= 0) {
            //Duplique le contact client sur le lead
            if (!userLead.contacts) userLead.contacts = [];
            userLead.contacts.push(userLead.client.contact);
        }
        else if (userLead.contacts) {
            //Récupération des modifications contact client pour contact lead
            var commonContact = userLead.contacts.filter(contact => contact?.contactType === userLead.client.contact.contactType);
            if (commonContact.length === 1) {
                commonContact[0].title = userLead.client.contact.title;
                commonContact[0].name = userLead.client.contact.name;
                commonContact[0].firstName = userLead.client.contact.firstName;
                commonContact[0].tel = userLead.client.contact.tel;
                commonContact[0].gsm = userLead.client.contact.gsm;
                commonContact[0].email = userLead.client.contact.email;
                commonContact[0].comments = userLead.client.contact.comments;
                commonContact[0].extLink = userLead.client.contact.extLink;
            }
        }
    }
    if (userLead.client) {
        userLead.client.idClient = userLead.clientID;
        if (!userLead.client.address?.idAddress && userLead.client.addressID) userLead.client.address.idAddress = userLead.client.addressID;
    }

    //Gestion ForcedCreate
    /*var forcedCreate = (userLead.idLead && !isUpdate) ? userLead.idLead : 0;
    if (forcedCreate) {
        userLead.idLead = 0;
        userLead.statusID = 3002;
        userLead.extras.forEach(extra => {
            extra.idExtra = 0;
            extra.leadID = 0;
        });
    }*/
    return userLead;
}

export async function saveLead(userLead, dataLead, isUpdate, i18nManager, callback) {
    dataLead = dataLead || {};

    Swal.fire({
        title: i18nManager.t("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    try {
        userLead = prepareLead(userLead, dataLead, isUpdate);

        console.debug(userLead);
        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
        return commonFunc.postMethod(isUpdate ? "../api/lead/UpdateLead" : "../api/lead/CreateLead", userLead).then((response) => {
            return new Promise((resolve, reject) => {
                var data = response.data;
                if (data?.isSuccess) {

                    try {
                        var dlModal;

                        var callbackSaveProc = () => {

                            if (dlModal) {
                                dlModal.unmount();
                                dlModal = null;
                            }

                            var finalizeLeadProc = () => {
                                if (userLead.cNoSwalMode) {
                                    if (callback && typeof (callback) === "function") { callback(data); }
                                }
                                else {
                                    var customSwalProps = {};
                                    if (userLead.cToastMode) {
                                        customSwalProps.backdrop = false;
                                        customSwalProps.position = "top-end";
                                        customSwalProps.timer = 1000;
                                        customSwalProps.showConfirmButton = false;
                                    }
                                    Swal.fire({
                                        ...customSwalProps,
                                        icon: "success",
                                        title: i18nManager.t("gal_success"),
                                        html: (isUpdate ? i18nManager.t("gal_successUpd") : i18nManager.t("gal_successAdd")),
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false
                                    }).then((result) => {
                                        /*if (context.state.curStatus !== data.result.statusID) {
                                            context.setState({ curStatus: data.result.statusID });
                                            context.refreshCb = () => {
                                                showDtSelID("tableLeads", data.result.idLead);
                                            };
                                        }
                                        else {
                                            context.getLeads(0, true, () => {
                                                showDtSelID("tableLeads", data.result.idLead);
                                            });
                                        }*/
                                        if (callback && typeof (callback) === "function") { callback(data); }
                                    });
                                }

                                data.result.idResponse = data.result.idLead;
                                resolve(data.result);
                            };

                            var asyncJobs = [];

                            //MAJ sous-objets Lead
                            if (isUpdate) {
                                /*if (userLead.client) {
                                    console.debug(dataLead.client);
    
                                    //MAJ Client
                                    if (!userLead.client.avoidMerge) {
                                        userLead.client = commonFunc.mergeDeep({}, dataLead.client, userLead.client);
    
                                        //userSite.contacts = null;
                                        //userSite.agreements = null;
                                        //userSite.clientFiles = null;
                                        //userSite.clientParents = null;
                                        //userSite.demands = null;
                                        //userSite.flows = null;
                                        //userSite.matchesAssigned = null;
                                        //userSite.models = null;
                                        userLead.client.accountUser = null;
                                        userLead.client.billingFirm = null;
                                        userLead.client.category = null;
                                        userLead.client.parent = null;
                                        userLead.client.group = null;
                                        userLead.client.site = null;
                                        userLead.client.extraSite = null;
                                        userLead.client.status = null;
                                        userLead.client.subStatus = null;
                                        userLead.client.tenantUserAccess = null;
                                    }
    
                                    console.debug(userLead.client);
                                    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                                    asyncJobs.push(commonFunc.postMethod("../api/client/UpdateClient", userLead.client).then((response) => {
                                        if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                                        return new Promise((resolve, reject) => {
                                            resolve(response);
                                        });
                                    }).catch(error => {
                                        return new Promise((resolve) => {
                                            resolve({ isSuccess: false, errorMessage: error });
                                        });
                                    }));
    
                                    //MAJ ClientContact
                                    if (userLead.client.contacts?.length) {
                                        userLead.client.contacts.forEach(dataElem => {
                                            if (!dataElem.avoidMerge) {
                                                dataElem.status = null;
                                                dataElem.category = null;
                                                dataElem.custom = null;
                                                dataElem.parent = null;
                                                dataElem.site = null;
                                                dataElem.extraSite = null;
                                                dataElem.client = null;
                                                dataElem.material = null;//Patch Upd Contact
                                                dataElem.employee = null;//Patch Upd Contract
                                                dataElem.report = null;//Patch Upd Contract
                                                dataElem.lead = null;//Patch Upd Contract
                                                dataElem.ticket = null;//Patch Upd Contract
                                                dataElem.service = null;//Patch Upd Contract
                                            }
    
                                            console.debug(dataElem);
                                            //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                                            asyncJobs.push(commonFunc.postMethod(dataElem.idContact > 0 ? "../api/client/UpdateClientContact" : "../api/client/CreateClientContact", dataElem).then((response) => {
                                                if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                                                return new Promise((resolve, reject) => {
                                                    resolve(response);
                                                });
                                            }).catch(error => {
                                                return new Promise((resolve) => {
                                                    resolve({ isSuccess: false, errorMessage: error });
                                                });
                                            }));
                                        });
                                    }
                                }*/
                                if (userLead.contacts) {
                                    //MAJ LeadContact
                                    if (userLead.contacts?.length) {
                                        userLead.contacts.forEach(dataElem => {
                                            if (!dataElem.avoidMerge) {
                                                dataElem.status = null;
                                                dataElem.category = null;
                                                dataElem.custom = null;
                                                dataElem.parent = null;
                                                dataElem.site = null;
                                                dataElem.extraSite = null;
                                                dataElem.client = null;
                                                dataElem.material = null;//Patch Upd Contact
                                                dataElem.employee = null;//Patch Upd Contract
                                                dataElem.report = null;//Patch Upd Contract
                                                dataElem.lead = null;//Patch Upd Contract
                                                dataElem.ticket = null;//Patch Upd Contract
                                                dataElem.service = null;//Patch Upd Contract
                                            }
                                            dataElem.leadID = data.result.idLead || userLead.idLead;

                                            console.debug(dataElem);
                                            //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                                            asyncJobs.push(commonFunc.postMethod(dataElem.idContact > 0 ? "../api/lead/UpdateLeadContact" : "../api/lead/CreateLeadContact", dataElem).then((response) => {
                                                if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                                                return new Promise((resolve, reject) => {
                                                    resolve(response);
                                                });
                                            }).catch(error => {
                                                return new Promise((resolve) => {
                                                    resolve({ isSuccess: false, errorMessage: error });
                                                });
                                            }));
                                        });
                                    }
                                }

                                Promise.all(asyncJobs).then(results => {
                                    var errorMessage = false;
                                    var flagSuccess = true;
                                    results.forEach(res => {
                                        if (res && res.data) {
                                            flagSuccess &= res.data.isSuccess;
                                            if (!res.data.isSuccess) errorMessage = res.data.errorMessage;
                                        }
                                        else {
                                            flagSuccess = false;
                                            errorMessage = res.errorMessage;
                                        }
                                    });

                                    if (flagSuccess) {
                                        finalizeLeadProc();
                                    }
                                    else {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Erreur",
                                            html: "Erreur lors de l'enregistrement des informations :<br>" + errorMessage
                                        }).then(() => {
                                            if (callback && typeof (callback) === "function") { callback(data); }
                                            data.result.idResponse = data.result.idLead;
                                            resolve(data.result);
                                        });
                                    }
                                });
                            }
                            else {
                                //Suppression Lead pour ForcedCreate
                                /*if (forcedCreate) {
                                    commonFunc.postMethod("../api/lead/RemoveLead", { id: forcedCreate, isPermanent: false }).then((response) => {
                                        //if (response.data?.isSuccess) {
                                        //    var mFiles = { id: id, targetId: removeInfos.id, isPermanent: true };
                                        //    postMethod("../api/reports/MigrateFiles", mFiles, function (dataFilesMigration) {
                                        //        if (dataFilesMigration.isSuccess) {
        
                                        //            if (assignAndSend) {
                                        //                //assignDlgItv(id, itv, ad2, callbackRemoveProc);
                                        //                assignDlgItv(id, itv, ad2, callbackSaveProc);
                                        //            }
                                        //            else {
                                        //                callbackSaveProc();
                                        //            }
                                        //        } else {
                                        //            Swal.close();
                                        //            Swal.fire({
                                        //                type: 'error',
                                        //                title: "Echec de migration des documents de la pochette d'origine",
                                        //                html: "<p>" + dataFilesMigration.errorMessage + "</p>",
                                        //            });
                                        //        }
                                        //    });
                                        //} else {
                                        //    Swal.close();
                                        //    Swal.fire({
                                        //        type: 'error',
                                        //        title: "Echec de la suppression de la pochette d'origine",
                                        //        html: "<p>" + dataRemove.errorMessage + "</p>",
                                        //    });
                                        //}
                                    });
                                }*/

                                finalizeLeadProc();
                            }
                        };

                        var dlSubModal;

                        var manageFiles = () => {

                            if (dlSubModal) {
                                dlSubModal.unmount();
                                dlSubModal = null;
                            }


                            if (userLead.localFiles?.length) {
                                dlModal = createRoot(document.createElement('div'));
                                dlModal.render(<ExtUpload url={`../api/lead/UploadLeadFiles`} bindID={data.result.idLead} fileTypeID={"LEAD"} files={userLead.localFiles} callback={callbackSaveProc} />);
                            }
                            else {
                                callbackSaveProc();
                            }
                        };


                        if (userLead.subLead && !isUpdate) {
                            var manageSubLead = (overrideServiceID) => {
                                userLead.subLead.parentID = data.result.idLead;
                                userLead.subLead.title = data.result.title;
                                userLead.subLead.email = userLead.email;
                                userLead.subLead.tel = userLead.tel;
                                userLead.subLead.gsm = userLead.gsm;
                                userLead.subLead.dSysNotif = userLead.dSysNotif;
                                //userLead.subLead.refExtID = userLead.refExtID;
                                //userLead.subLead.extRef = userLead.extRef;
                                userLead.subLead.comments = userLead.comments;
                                //userLead.subLead.description = userLead.description;
                                //userLead.subLead.title = userLead.title;
                                //userLead.subLead.b2b = userLead.b2b;
                                userLead.subLead.stepID = userLead.stepID;
                                //userLead.subLead.contacts = userLead.contacts;
                                userLead.subLead.startDate = userLead.startDate;
                                userLead.subLead.assignSiteID = userLead.assignSiteID;
                                userLead.subLead.extSite = userLead.extSite;
                                userLead.subLead.priority = userLead.priority;
                                userLead.subLead.statusID = userLead.statusID;
                                userLead.subLead.addressID = userLead.addressID;
                                userLead.subLead.address = userLead.address;

                                var localLead = prepareLead(userLead.subLead, {}, false);

                                if (overrideServiceID) localLead.serviceID = overrideServiceID;

                                commonFunc.postMethod("../api/lead/CreateLead", localLead).then((responseSub) => {
                                    var dataSub = responseSub.data;
                                    if (dataSub?.isSuccess) {

                                        if (!overrideServiceID) {
                                            if (localLead.localFiles?.length) {
                                                dlSubModal = createRoot(document.createElement('div'));
                                                dlSubModal.render(<ExtUpload url={`../api/lead/UploadLeadFiles`} bindID={dataSub.result.idLead} fileTypeID={"LEAD"} files={localLead.localFiles} callback={manageFiles} />);
                                            }
                                            else {
                                                manageFiles();
                                            }
                                        }

                                    } else {
                                        var supErrors = "";
                                        if (dataSub.errors && dataSub.errors.length) {
                                            supErrors = dataSub.errors.map((error) => {
                                                return "<br>" + error.desc + "(" + error.value + ")";
                                            });
                                        }
                                        Swal.fire({
                                            icon: "error",
                                            title: i18nManager.t("gal_fail"),
                                            html: i18nManager.t("gal_errorSave") + " :<br>" + dataSub.errorMessage + supErrors
                                        });
                                    }
                                });
                            };

                            if (userLead.subLead.serviceID === 901) {
                                manageSubLead(904);
                                manageSubLead();
                            }
                            else {
                                manageSubLead();
                            }
                        }
                        else {
                            manageFiles();
                        }

                    }
                    catch (e) {
                        Swal.close();
                        Swal.fire({
                            icon: "error",
                            title: "Erreur",
                            didOpen: () => { Swal.hideLoading() },
                            html: "Erreur lors du traitement des sous-éléments formulaire :<br>" + e
                        });
                        resolve(data);
                    }
                } else {
                    var supErrors = "";
                    if (data.errors && data.errors.length) {
                        supErrors = data.errors.map((error) => {
                            return "<br>" + error.desc + "(" + error.value + ")";
                        });
                    }
                    Swal.fire({
                        icon: "error",
                        title: i18nManager.t("gal_fail"),
                        html: i18nManager.t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                    });
                    resolve(data);
                }
            });
        });
    }
    catch (e) {
        Swal.close();
        Swal.fire({
            icon: "error",
            title: "Erreur",
            didOpen: () => { Swal.hideLoading() },
            html: "Erreur lors de l'envoi du formulaire :<br>" + e
        });
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false, errorMessage: ("Erreur lors de l'envoi du formulaire :<br>" + e) });
        });
    }
}

export function getLeadModels(categ) {
    return new Promise((resolve, reject) => {
        var args = { filter: "lead", useParentSite: true, excludeMode: 1 };
        if (categ) args.categ = categ;
        commonFunc.getMethod("../api/data/GetAllModels", args).then((responseModels) => {
            var dataModels = responseModels.data;
            if (dataModels.isSuccess) {

                var leadModels = {};
                //dataModels.result.models.forEach((model) => {
                dataModels.result.map(model => model.tag).forEach((model) => {
                    var modelObj = JSON.parse(model.value);
                    if (!modelObj.objType) {//Array.isArray(modelObj)
                        var useSub = false;
                        Object.keys(modelObj).forEach(key => {
                            var subModel = modelObj[key];
                            if (subModel.objType) {
                                useSub = true;
                                leadModels[key] = subModel;
                            }
                        });
                        if (!useSub) leadModels[model.extID] = modelObj;
                    }
                    else leadModels[model.extID] = modelObj;
                });
                resolve({ models: leadModels, response: dataModels });
            }
            else resolve();
        });
    });
}

export function showDialogLead(title, tag, curLead, leadModels, saveLeadVar, saveCb, modalGenManager, parentProps, i18nManager, isDuplicate) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                //isUpdate = false;//TEMP : Recréation du lead (voir pour les associations client etc..)
                saveLeadVar(data, curLead, isUpdate, i18nManager, saveCb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();
                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (leadModels[tag]) {
        if (isDuplicate && !(curLead.parentID > 0)) curLead.parentID = curLead.idLead;

        modalRoot = createRoot(document.createElement('div'));
        //modalRoot.render(<LeadModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={leadModels[tag]} modelsList={leadModels} dataLead={curLead} callback={callbackModal}></LeadModal>);
        modalRoot.render(<LeadModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={leadModels[tag]} configTag={tag} modelsList={leadModels} dataLead={curLead} isDuplicate={isDuplicate} i18nManager={i18nManager} callback={callbackModal}></LeadModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

export function dialogAltLead(title, tag, curLead, leadModels, process, scheduleVisitCb, modalGenManager, parentProps, i18nManager) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                var cb = () => {
                    var req = { id: data.idLead, newStatus: (tag === "LEADLOSS" ? 3006 : 3004), newStep: -1 };
                    commonFunc.postMethod("../api/lead/UpdateStatus", req).then((response) => {
                        if (response.data && response.data.isSuccess) {
                            if (scheduleVisitCb && typeof (scheduleVisitCb) === "function") { scheduleVisitCb(data); }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: i18nManager.t("gal_fail"),
                                html: i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                            });
                        }
                        resolve(response.data);
                    });
                };

                process(data, curLead, isUpdate, i18nManager, cb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();

                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (leadModels[tag]) {
        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<LeadModal supClasses={"visitModal"} modalGenManager={modalGenManager} noScroll size={"lg"} props={parentProps} title={title} configModel={leadModels[tag]} configTag={tag} locked={tag === "DLG_LEAD"} modelsList={leadModels} dataLead={curLead} i18nManager={i18nManager} callback={callbackModal}></LeadModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

export function finalizeProject(context, project, version, callback) {
    /*var projectUpdate = () => {
        project.serviceID = 801;
        project.cNoSwalMode = true;
        saveLead(project, {}, true, context.props.i18nManager, () => {
            Swal.fire({
                icon: "success",
                title: context.props.i18nManager.t("gal_success"),
                html: "Finalisation effectué avec succès",
                didOpen: () => { Swal.hideLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            }).then((result) => {
                //if (callback && typeof (callback) === "function") { callback(); }
                context.getLeads(3000, true, () => { });
            });
        });
    };*/

    var isProjectTech = (context.state.pageModels === "PTECHLEAD");

    //Finalisation
    if (version.serviceID === 801 || isProjectTech) {
        //TODO : modal
        //projectUpdate();

        project.cNoSwalMode = true;
        //version.cToastMode = true;

        var closeCb = (data) => {
            if (data?.isSuccess) {
                context.updateLeadStatus(data.result.statusID, -1, null, version.idLead, true, true).then(() => {
                    Swal.fire({
                        icon: "success",
                        title: context.props.i18nManager.t("gal_success"),
                        html: "Clôture du projet effectué avec succès",
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then(() => {
                        //if (callback && typeof (callback) === "function") { callback(data); }
                        context.getLeads(3000, true, () => { });
                    });
                });

                /*version.statusID = data.result.statusID;
                saveLead(version, {}, true, context.props.i18nManager, () => {
                    if (callback && typeof (callback) === "function") { callback(data); }
                });*/
            }
            else {
                if (callback && typeof (callback) === "function") { callback(data); }
            }
        };

        showDialogLead(context.props.i18nManager.t("lead.closeProject"), "CLOSEPROJECT", project, context.leadModels, saveLead, closeCb, context.modalGenManager, context.props, context.props.i18nManager);
    }
    //Passage Acte
    else {
        Swal.fire({
            icon: "question",
            title: isProjectTech ? "Validation Dossier" : "Passage en Acte",
            html: "Etes-vous sûr de vouloir apporté cette modification ?",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            confirmButtonText: context.props.i18nManager.t("gal_yes"),
            cancelButtonText: context.props.i18nManager.t("gal_no"),
        }).then((result) => {
            if (result.value) {
                var newVersion = Object.assign({}, version);
                newVersion.idLead = 0;
                newVersion.addressID = 0;
                newVersion.address.idAddress = 0;
                newVersion.statusID = 3001;
                //newVersion.stepID = 3110;
                if (!isProjectTech) newVersion.serviceID = 801;
                newVersion.categoryID = (isProjectTech ? 201 : 1);
                newVersion.recall = 1;
                var prevSessId = newVersion.extras?.filter(extra => extra.name === "sessionId");
                newVersion.extras?.forEach(extra => {
                    extra.idExtra = 0;
                    extra.leadID = 0;
                    if (extra.name === "sessionId") extra.value = "";
                    if (extra.name === "previousSessionId" && prevSessId?.length) extra.value = prevSessId[0].value;
                });
                newVersion.cNoSwalMode = true;
                saveLead(newVersion, {}, false, context.props.i18nManager, () => {
                    context.updateLeadStatus(3007, -1, null, version.idLead, true, true).then(() => {
                        //projectUpdate();
                        Swal.fire({
                            icon: "success",
                            title: context.props.i18nManager.t("gal_success"),
                            html: "Finalisation effectué avec succès",
                            didOpen: () => { Swal.hideLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        }).then((result) => {
                            //if (callback && typeof (callback) === "function") { callback(); }
                            context.getLeads(3000, true, () => { });
                        });
                    });
                });
            }
        });
    }
}

export function sendEmailDialog(lead, dataCfg, i18nManager) {
    var id = lead.idLead;
    if (parseInt(id) > 0) {
        var title = i18nManager.t("lead.title") + " • " + lead.title + " • " + lead.client?.name + " " + lead.client?.firstName + (lead.client?.compagny ? (" - " + lead.client?.compagny) : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} leadId={id} lead={lead} dataCfg={dataCfg} i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}

export function sendRecapEmailDialog(lead, dataCfg, i18nManager) {
    var id = lead.idLead;
    if (parseInt(id) > 0) {
        var title = i18nManager.t("lead.title") + " • " + lead.title + " • " + lead.client?.name + " " + lead.client?.firstName + (lead.client?.compagny ? (" - " + lead.client?.compagny) : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} leadId={id} lead={lead} dataCfg={dataCfg} cfgTag="EMLRCP_CFG" i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}

export function LeadModal({ title, props, modalGenManager, noScroll, noButtons, noSubmit, supClasses, size, dialogBodyStyle, configModel, configTag, locked, modelsList, dataLead, isDuplicate, i18nManager, callback }) {
    configModel = JSON.parse(JSON.stringify(configModel));

    const [initialized, setInitialized] = React.useState(configTag !== "DLG_LEAD" && configTag !== "NEWPERSON");
    const [dlgLead, setDlgLead] = React.useState(dataLead);


    React.useEffect(() => {
        if (!initialized && (configTag === "DLG_LEAD" || configTag === "NEWPERSON")) {
            var args = {};
            //args.id = dataLead?.clientID;
            //args.level = 2;
            args.id = dataLead?.idLead;
            args.level = 3;
            if (parseInt(args.id) > 0) {
                Swal.fire({
                    title: i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                //commonFunc.getMethod("../api/client/GetClient", args).then((response) => {
                commonFunc.getMethod("../api/lead/GetLead", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        Swal.close();

                        if (data.result) {
                            //dataLead.client = data.result;
                            //var newLead = dataLead;
                            var newLead = data.result;
                            newLead.client.contact = newLead.client?.contacts?.filter(contact => {
                                if (!contact.address) contact.address = { "idAddress": contact.addressID, "pc": 0, "city": "", "categ": "SITE", "title": "Adresse", "addressMain": "N/A" };// /!\ TODO : Perte valeur adresse du contact
                                return contact.contactType === "Prospect Appelant";
                            });
                            if (newLead.client?.contact?.length) newLead.client.contact = newLead.client.contact[0];
                            //else if (newLead.client?.contacts?.length) newLead.client.contact = newLead.client.contacts[0];
                            if (configTag === "NEWPERSON" && newLead.clientID <= 0) newLead.client = null;
                            if (isDuplicate && !(newLead.parentID > 0)) newLead.parentID = newLead.idLead;
                            setDlgLead(newLead);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: i18nManager.t("gal_error"),
                            html: i18nManager.t("client.failLoadClient") + " :<br>" + data.errorMessage
                        });
                    }
                    setInitialized(true);
                });

            }
            else {
                setInitialized(true);
            }
        }
    }, []);


    if (locked) {
        configModel.disabled = true;
        configModel.subType = "breadcrumbNav";
        size = "xl";
        noButtons = false;
        noSubmit = true;
    }
    else if (configTag === "DLG_LEAD" && dlgLead) {
        configModel.subType = "breadcrumbNav";
    }

    return (
        <Modal isOpen={true} className={`dlg-step modal-lead ${noScroll ? "modal-noscroll" : ""} ${supClasses}`} size={size ? size : "xl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2 pt-0  scrollable" style={{ overflowX: "hidden", ...dialogBodyStyle }}>
                {initialized && <AGenerateModel parentProps={{ type: "lead", dataCfg: props.dataCfg }} ref={modalGenManager} noButtons onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={props} checkRights={props.checkRights} getRoutes={props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dlgLead} isStartDuplicate={isDuplicate} />}

                {/*<FilesCustom className="reportDlg-files" title="FICHIERS JOINTS" bindID={elemID} checkRights={props.checkRights} fileTypeID={entity} src={null} srcName={elemName}
                    files={files} setFiles={(compFiles) => { setFiles(compFiles) }}
                    noUploads={true} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={"PJ"}
                    altFilesTypes={`../api/${entity}/Get${entity}FilesType`} altFilesUrl={`../api/${entity}/Get${entity}Files`}
                    altRemoveFilesUrl={`../api/${entity}/Remove${entity}File`} altUploadFilesUrl={`../api/${entity}/Upload${entity}Files`} />*/}
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {noButtons ? "" :
                    <>{noSubmit ? "" : ((dlgLead?.idLead && !isDuplicate) ? <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>Modifier</Button> : <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                    }}><i className="fa fa-plus"></i>Ajouter</Button>)}
                        <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button></>
                }
            </ModalFooter>
        </Modal>
    );
}

function FlowsModal({ t, title, noScroll, idElem, dataFlows, parentContext, callback }) {

    const [flows, setFlows] = React.useState(dataFlows || []);

    React.useEffect(() => {
        //initFlows();
    }, []);

    function initFlows() {
        var args = { id: idElem };
        commonFunc.getMethod("../api/lead/GetLeadFlows", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {

                    Swal.close();


                    setFlows(response.data.result);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: "Erreur de récupération de l'historique :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: "Erreur de récupération de l'historique : No Response"
                });
            }
        });
    }

    return (
        <Modal isOpen={true} className={`modal-flows ${noScroll ? "modal-noscroll" : ""}`} size="xxl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <Historical type="modelFlows" elemId={0} hideRefresh loadExternalParent={() => { return new Promise((resolve, reject) => { resolve(flows); }); }} url={""} getRoutes={parentContext.props.getRoutes} shouldRender={true} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}

function PreviewModal({ title, url, successBtnCb, hideEmail, lead, parentContext, callback }) {

    //console.debug("render modal");

    return (
        <Modal isOpen={true} className="modal-report" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2">
                <PdfViewer url={url} containerId="embdActFinalPDf" shouldRender={true} style={{ minHeight: "740px" }}></PdfViewer>
            </ModalBody>
            <ModalFooter className="px-2 d-block">
                {!hideEmail && <Button className="px-3 float-start" color="primary" onClick={() => { sendEmailDialog(lead, parentContext.props.dataCfg, parentContext.props.i18nManager); }}><i className="fa fa-envelope"></i>Envoi email</Button>}

                <Button className="px-3 float-end" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
                {successBtnCb ? <Button className="px-3 float-end" color="success" onClick={() => { successBtnCb(); }}>Marquer comme envoyé</Button> : ""}
            </ModalFooter>
        </Modal>
    );
}





//Création du schéma pour le paramètrage du formulaire
const itvModalSchema = yup.object().shape({
    fromEmail: yup.object().required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    targetsEmail: yup.array().min(1, "Veuillez renseigner un email").required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    files: yup.array(),//.required("Ce champ est obligatoire"),
    objectLabel: yup.string().required("Ce champ est obligatoire")
}).required();

function EmailModal({ title, leadId, lead, dataCfg, cfgTag, i18nManager, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        initEmailModal();
    }, []);

    const [froms, setFroms] = React.useState([]);
    const [contacts, setContacts] = React.useState([]);
    const [files, setFiles] = React.useState([]);
    const [objEml, setObjEml] = React.useState(null);
    const [emailStatus] = React.useState(<Col lg="10" className="alert alert-sm mb-0 wait" id="errorEmailAlert"><span className="input-icon">En Attente</span><span className="ms-3">Patientez SVP...</span></Col>);
    const [modelTemplates, setModelTemplates] = React.useState([]);
    const [template, setTemplate] = React.useState("");

    const editorRef = React.useRef(null);

    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(itvModalSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }

    /*const { ref: refTgtEmail, ...restTgtEmail } =*/ register("targetsEmail");
    /*const { ref: refFiles, ...restFiles } =*/ register("files", { value: [] });
    const { ref: refObjectLabel, ...restObjectLabel } = register("objectLabel");

    function initEmailModal() {
        Swal.fire({
            title: i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var argsModel = { id: lead.assignSiteID, level: 2 };
        commonFunc.getMethod("../api/site/GetSite", argsModel).then((responseSite) => {
            if (responseSite.data.isSuccess) {
                lead.extSite = responseSite.data.result;

                var argsModel = { id: -1, categ: "LEAD" };
                commonFunc.getMethod("../api/lead/GetLeadModels", argsModel).then((response) => {
                    if (response.data.isSuccess) {
                        if (response.data.result?.models) {
                            var mailModel = response.data.result?.models.filter(model => model.extID === (cfgTag || "EML_CFG"));
                            if (mailModel.length) {
                                var objEmlCurr = JSON.parse(mailModel[0].value);
                                setObjEml(objEmlCurr);

                                if (objEmlCurr?.Email?.Subject) setValue("objectLabel", objEmlCurr?.Email?.Subject);
                                if (objEmlCurr?.Email?.From) {
                                    setFroms([{ value: objEmlCurr.Email.From.Item1, label: objEmlCurr.Email.From.Item2 }, { value: lead.extSite?.email, label: lead.extSite?.name + " (" + lead.extSite?.email + ")" }]);
                                    if (objEmlCurr.SetDefaultFromSvcIDs && objEmlCurr.SetDefaultFromSvcIDs[lead.serviceID]) {
                                        var defaultEmail = objEmlCurr.SetDefaultFromSvcIDs[lead.serviceID];
                                        if (defaultEmail === objEmlCurr.Email.From.Item1) setValue("fromEmail", { email: objEmlCurr.Email.From.Item1, name: objEmlCurr.Email.From.Item2, firstName: "" });
                                        else setValue("fromEmail", { email: defaultEmail, name: defaultEmail, firstName: "" });
                                    }
                                    else setValue("fromEmail", { email: lead.extSite?.email, name: lead.extSite?.name, firstName: "" });
                                }
                                else {
                                    setValue("fromEmail", { email: lead.extSite?.email, name: lead.extSite?.name, firstName: "" });
                                }

                                var args = { id: leadId };
                                /*commonFunc.getMethod("../api/lead/GetLeadContacts", args).then((response) => {
                                    var data = response.data;
                                    if (data.isSuccess) {
                                        var defaultClient = [];
                                        if (!commonFunc.isBlank(lead.client?.email)) defaultClient.push({ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName });

                                        var contacts = [...defaultClient, ...data.result];

                                        setContacts(contacts);
                                    }
                                    //else {
                                    //    Swal.fire({
                                    //        icon: "warning",
                                    //        title: "Attention",
                                    //        html: "Aucun contacts"
                                    //    });
                                    //}
                                });*/
                                var contacts = [];
                                var defaultClient = [];
                                if (!cfgTag || cfgTag === "EML_CFG") {
                                    if (!commonFunc.isBlank(lead.client?.email)) {
                                        defaultClient.push({ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName });
                                    /*if (!cfgTag || cfgTag === "EML_CFG")*/ setValue("targetsEmail", [defaultClient[0]]);
                                    }

                                    contacts = [...defaultClient, ...lead.contacts];
                                }

                                setContacts(contacts);
                                //setValue("targetsEmail", [{ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName }]);

                                if (objEmlCurr?.IncludeFiles) {
                                    //Appel réseau plutôt que dépendance sur lead qui n'est pas actualisé juste après génération PDF
                                    var argsFiles = { bindID: args.id, fileId: -1 };
                                    commonFunc.getMethod("../api/lead/GetLeadFiles", argsFiles).then((response) => {//GetReportFinalFiles
                                        var data = response.data;
                                        var filteredFiles = [];
                                        if (lead.leadFiles?.length > 0) {
                                            filteredFiles = lead.leadFiles.map(file => file.file);
                                        }
                                        if (data.isSuccess && data.count > 0) {
                                            data.result.forEach((distantFile) => {
                                                var founded = filteredFiles.filter(localFile => localFile.idFile === distantFile.idFile);
                                                if (founded.length <= 0) filteredFiles.push(distantFile);
                                            });
                                        }

                                        if (objEmlCurr.Email?.FilesTypes) filteredFiles = filteredFiles.filter(file => objEmlCurr.Email.FilesTypes.indexOf(file.categ) >= 0);

                                        if (filteredFiles.length > 1) {
                                            filteredFiles = filteredFiles.sort((a, b) => {
                                                return moment(b.dSysMod).diff(a.dSysMod, "seconds");
                                            });
                                        }

                                        setFiles(filteredFiles);
                                        if (filteredFiles.length) setValue("files", [filteredFiles[0]]);
                                    });
                                }

                                /*commonFunc.getMethod("../weatherforecast/WFGetEmailStatus", null).then((response) => {
                                    if (response.data.isSuccess) {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 success alert-success" id="errorEmailAlert"><span className="input-icon">Actif</span><span className="ms-3"></span></Col>);
                                    } else {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 failure alert-danger" id="errorEmailAlert"><span className="input-icon">InActif</span><span className="ms-3">{response.data.errorMessage}</span></Col>);
                                    }
                                });*/

                                if (objEmlCurr?.Email?.ModelCateg && objEmlCurr?.Email?.ModelExtId) {
                                    //var argsModel = { filter: "lead", useParentSite: true, excludeMode: 0, categ: objEmlCurr?.Email?.ModelCateg };
                                    //commonFunc.getMethod("../api/data/GetAllModels", argsModel).then((response) => {
                                    var argsModel = { id: -1, categ: objEmlCurr?.Email?.ModelCateg };
                                    commonFunc.getMethod("../api/lead/GetLeadModels", argsModel).then((response) => {
                                        if (response.data.isSuccess && response.data.result) {
                                            //console.debug(response.data.result);
                                            var mailModel = response.data.result.models.filter(model => objEmlCurr?.Email?.ModelExtId.indexOf(model.extID) >= 0);
                                            if (mailModel.length) {
                                                setModelTemplates(mailModel);
                                                updateHtmlContent(mailModel[0]);
                                            }


                                        }/* else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Echec",
                                                html: "Echec du chargement du template l'email<br/>" + response.data.errorMessage
                                            });
                                        }*/
                                    });
                                }

                                Swal.close();

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec du chargement de la configuration email<br/>Configuration introuvable"
                                });
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec du chargement de la configuration email<br/>Aucune configuration"
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec du chargement de la configuration email<br/>" + response.data.errorMessage
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de récupération infos agences<br/>" + responseSite.data.errorMessage
                });
            }
        });
    }

    function updateHtmlContent(model, customContent) {
        var objHtml = JSON.parse(model.value);

        var htmlProc = () => {
            var content = customContent || objHtml.Details;
            var temp = document.createElement('div');
            temp.innerHTML = content;

            temp.querySelectorAll("[data-bind], [data-bindtype]").forEach((element) => {
                var valueBind;
                if (element.getAttribute("data-bindtype") === "address") {
                    valueBind = commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressMain") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressPlus") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressPlus2") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".pc") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".city");
                }
                else if (element.getAttribute("data-bindtype")?.startsWith && element.getAttribute("data-bindtype").startsWith("contacts;")) {
                    valueBind = "";
                    var contacts = commonFunc.getValue(lead, element.getAttribute("data-bind"));
                    if (contacts?.length) {
                        var filteredContacts = contacts.filter(contact => contact.contactType === element.getAttribute("data-bindtype").replace("contacts;", ""));
                        if (filteredContacts.length) {
                            valueBind = commonFunc.getValue(filteredContacts[0], element.getAttribute("data-subbind")) || ""
                        }
                    }
                    if (commonFunc.isBlank(valueBind) && element.getAttribute("data-fallback")) {
                        var subObj = commonFunc.getValue(lead, element.getAttribute("data-fallback"));
                        if (subObj) valueBind = commonFunc.getValue(subObj, element.getAttribute("data-subbind")) || "";
                    }
                }
                else {
                    valueBind = commonFunc.getValue(lead, element.getAttribute("data-bind")) || "";
                }

                if (element.getAttribute("data-format") === "phone") {
                    valueBind = valueBind.replaceAll(" ", ".");
                }

                element.innerHTML = valueBind;
            });
            setTemplate("<br/>" + temp.innerHTML);
        };


        if (objHtml.ShopOrderDependence) {
            commonFunc.getMethod("../api/lead/GetLastShopOrderFromLead", { leadId: leadId }).then((response) => {
                if (response.data.isSuccess) {
                    lead.shopOrder = response.data.result;

                    htmlProc();
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de récupération de la dépendance<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            htmlProc();
        }
    }

    function triggerSubmit(data) {

        Swal.fire({
            title: 'Envoi de l\'Email en cours...',
            didOpen: () => { Swal.showLoading() },
        });

        ///console.debug(data);
        var args = objEml.Email;
        args.BindID = leadId;
        args.From = { Item1: data.fromEmail.email, Item2: data.fromEmail.name + (data.fromEmail.firstName ? (" " + data.fromEmail.firstName) : "") };
        args.To = {};
        data.targetsEmail.forEach(target => { args.To[target.email] = target.name + (target.firstName ? (" " + target.firstName) : "") });
        args.Subject = data.objectLabel;
        args.Attachments = data.files;
        args.SrcObject = leadId;
        args.ModelBindID = leadId;

        args.HtmlMessage = editorRef.current ? editorRef.current.getContent() : "";
        args.PlainMessage = editorRef.current ? editorRef.current.getContent({ format: "text" }) : "";
        console.debug(args);
        //return;//TEMP
        commonFunc.postMethod("../api/lead/SendLeadEmail", args).then((response) => {
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: i18nManager.t("gal_success"),
                    html: "Email envoyé avec succès",
                    didOpen: () => { Swal.hideLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (callback && typeof (callback) === "function") { callback(data); }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de l'envoi de l'email<br/>" + response.data.errorMessage
                });
            }
        });
    }

    //console.debug("render modal");

    //console.debug(getValues());
    //console.debug(errors);

    var bindPropResult = "targetsEmail";
    //var currValue = "";
    var inputStyle = {};

    var onChange = () => { };

    var customOpt = [];
    contacts.forEach((option, index) => {
        customOpt.push({ value: option.email, label: option.name + " " + option.firstName + " (" + option.email + ")" });
    });
    /*if (getValues(bindPropResult)) currValue = getValues(bindPropResult);
    else if (customOpt.length) currValue = customOpt[0].value;*/

    var compArgs = {
        isMulti: true,
        id: "targetContactsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResult) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var contactSrc = contacts.filter(contact => contact.email === v.value);
                    if (contactSrc.length) return contactSrc[0];
                    else return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResult, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResult, e.value);
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResult) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValue)) {
                arrayOptions = currValue;
            }
            else if (currValue && currValue.split) {
                arrayOptions = currValue.split(";");
            }
            //console.debug(currValue);
            //console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOpt.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOpt.filter(opt => opt.value === currValue);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValue };
                }
                else {
                    option = (currValue ? currValue : "");
                }
            }
            return option;
        })(),*/
        options: customOpt,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (contacts?.length) {
        compArgs.key = "emails" + contacts?.length;
        if (!cfgTag || cfgTag === "EML_CFG") compArgs.defaultValue = { label: customOpt[0].label, value: customOpt[0].value };
    }


    var bindPropResultF = "fromEmail";
    var fromArgs = {
        isMulti: false,
        id: "fromsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultF) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultF, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultF, { email: e.value, name: e.label });
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResultF) ? true : false,
        options: froms,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (froms?.length) {
        fromArgs.key = "froms" + froms?.length;
        var defaultFrom = froms.filter(from => from.value === getValues("fromEmail")?.email);
        if (defaultFrom?.length) fromArgs.defaultValue = { label: defaultFrom[0].label, value: defaultFrom[0].value };
        else fromArgs.defaultValue = { label: froms[0].label, value: froms[0].value };
    }


    var bindPropResultFiles = "files";
    //var currValueFiles = "";

    var customOptFiles = [];
    files.forEach((option, index) => {
        customOptFiles.push({ value: option.idFile, label: option.name + " (" + option.prefix + ")" });
    });
    /*if (customOptFiles.length) {
        if (getValues(bindPropResultFiles)) currValue = getValues(bindPropResultFiles);
        else {
            var filteredFiles = files.filter(file => file.categ === "PDF");
            if (filteredFiles.length) {
                currValueFiles = filteredFiles[0].idFile;
            }
            else currValueFiles = customOpt[0].value; 
        }
    }*/

    var selFilesArgs = {
        isMulti: true,
        id: "targetFilesEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultFiles) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var fileSrc = files.filter(contact => contact.idFile === v.value);
                    if (fileSrc.length) return fileSrc[0];
                    else return null;
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultFiles, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultFiles, e.value);
            }
        },
        invalid: commonFunc.getValue(errors, bindPropResultFiles) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValueFiles)) {
                arrayOptions = currValueFiles;
            }
            else if (currValueFiles && currValueFiles.split) {
                arrayOptions = currValueFiles.split(";");
            }
            console.debug(currValueFiles);
            console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOptFiles.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOptFiles.filter(opt => opt.value === currValueFiles);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValueFiles };
                }
                else {
                    option = (currValueFiles ? currValueFiles : "");
                }
            }
            return option;
        })(),*/
        options: customOptFiles,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (files?.length) {
        selFilesArgs.key = "files" + files?.length;
        selFilesArgs.defaultValue = { label: customOptFiles[0].label, value: customOptFiles[0].value };
    }

    return (
        <Modal isOpen={true} className="modal-email" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title || "Transfert de Fichiers"}</ModalHeader>
            <ModalBody className="px-2">
                <Row className="m-0 mb-3 px-1 d-none">
                    <Col className="align-content-center text-lg-end" lg="2">
                        <label className="m-0">Etat du service:</label>
                    </Col>
                    {emailStatus}
                </Row>
                <div className="mail-box">
                    <Form id="frmsendmail" action="" className="form needs-validation" method="" onSubmit={handleSubmit(triggerSubmit)}>
                        <div className="mail-body">
                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">De:</label>
                                    </Col>
                                    <Col lg="8">
                                        {froms?.length ? <Select {...fromArgs} options={froms} /> : (() => {
                                            var email = getValues("fromEmail");
                                            return email ? (email.name + " (" + email.email + ");") : "";
                                        })()}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "fromEmail") ? "d-block" : ""}`}>{errors.fromEmail ? errors.fromEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">A:</label>
                                    </Col>
                                    <Col lg="8">
                                        {<CreatableSelect {...compArgs} />/*contacts?.length ? <CreatableSelect {...compArgs} /> : (() => {
                                            var emails = getValues("targetsEmail");
                                            return emails?.map(option => option.name + "(" + option.email + ");");
                                        })()*/}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "targetsEmail") ? "d-block" : ""}`}>{errors.targetsEmail ? errors.targetsEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">Objet:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Input id="targetSubject" name="Objet" placeholder="Objet" type="text" autoComplete="off" aria-autocomplete="none"
                                            innerRef={refObjectLabel} {...restObjectLabel}
                                            invalid={errors.objectLabel ? true : false} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "objectLabel") ? "d-block" : ""}`}>{errors.objectLabel ? errors.objectLabel.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {objEml?.IncludeFiles ? <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Fichiers:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Select {...selFilesArgs} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "files") ? "d-block" : ""}`}>{errors.files ? errors.files.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup> : ""}

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Type de message:</label>
                                    </Col>
                                    <Col lg="6">
                                        <Input id={"selectMsgType"} style={inputStyle} type="select" onChange={(e) => {
                                            var model = modelTemplates.filter(model => model.idModel === parseInt(e.target.value));
                                            if (model.length) {
                                                updateHtmlContent(model[0]);
                                            }
                                        }}>
                                            {modelTemplates.map((option, index) => <option key={"messagetype" + index} value={option.idModel}>
                                                {option.title}
                                            </option>)}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>

                        </div>
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            initialValue={template}
                            init={{
                                language: "fr_FR",
                                valid_elements: '*[*]',
                                valid_children: "+body[style]",
                                height: 410,
                                menubar: false,
                                //readonly: true, >> cf disabled
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | fontsize | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat',
                                content_style: `body { font-family:Helvetica,Arial,sans-serif; font-size:14px} 
                                #mtnfr {font-family:Nunito} 
                                .sepline { border: 1px dashed red; }
                                .displayNone { display: none }
                                .d-none { display: none }`
                            }}
                        />
                        <button type="button" id="btnSaveEmailSig" className="btn btn-sm btn-simple btn-dark btn-ok mt-3 d-none"><i className="fa fa-pencil-alt"></i>&nbsp;Définir signature</button>
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="primary" form="frmsendmail"><i className="fa fa-reply"></i>Envoyer</Button>
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageLeads));